import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import {
    Select,
    Button,
    Tile,
    Expansion,
    Checkbox,
    Range,
    Input, SelectMultiFilters
} from "../partials";
import {w, insertParam, processFilterOff, sortVehicles, getOdometerValues} from "./../utils";
import Overlay from "./Overlay";
import HeroDeal from "./HeroDeal";
import { isInitialValid  } from "~/js/utils";
import { Formik, Form } from 'formik';
import VehicleBrandHero from "./VehicleBrandHero";
import debounce from "lodash/debounce";
import moment from "moment";
import "../utils/vehicle-filters-float";
import VehicleFiltersTopbar from "../partials/VehicleFiltersTopbar";
import { processFilterOn} from "./../utils";
import { searchService } from "~/js/_services";
import * as Yup from "yup";

const north_island_string = "north-island";
const south_island_string = "south-island";


const url = window.location.href;
const hero_deal = window.hero_deal ?? null;
const brand_banner = window.brand_banner ?? null;
const on_sale_banner = window.on_sale_banner ?? null;
let regions = [];
let ribbonData = {};
const makes = window.makes_data ?? null;
const custom_filter_fields = [];

let colourTypes = window.colours_data ?? null;
const bodyTypes = window.types_data ?? null;
const reservedVehicles = window.reserved_vehicles_data ?? {};
const offerFilterDetails = window.offer_vehicle_filters ?? false;
let hideUI = false;
let vehicles = [];
let models = [];
let colourArray = []



const regionIsland = [
    {region: "auckland", island: north_island_string},
    {region: "wellington", island: north_island_string},
    {region: "lower-hutt", island: north_island_string},
    {region: "christchurch", island: south_island_string},
    {region: "dunedin", island: south_island_string},
]

let regionNorthIsland = {term_id: north_island_string, name: "North Island", label: "North Island", slug: north_island_string}
let regionSouthIsland = {term_id: south_island_string, name: "South Island", label: "South Island", slug: south_island_string}

const dealerships = [];



// Create an array of years avaliable
let years = [];

const odometer = getOdometerValues();

const sortOptions = [
    { value: "recent", label: "Recently Added" },
    { value: "new", label: "Newest Vehicles" },
    { value: "old", label: "Oldest Vehicles" },
    { value: "highest", label: "Highest Price" },
    { value: "lowest", label: "Lowest Price" },
    { value: "savings", label: "Highest Savings"},
];

// How many extra to show after clicking "show more"
const showingStep = 24;

// Create an array of years avaliable

const prices = [{ value: null, label: "Any" }];
const pricePlus = 120000; // Defines the plus price like "120k+"

for (let i = 0; i <= 24; i++) {
    prices.push({
        label: `${i * 5}k${i === 24 ? "+" : ""}`,
        value: i * 5 * 1000,
    });
}


const fuel_types = [
    'Electric (EV)',
    'Plug-in Hybrid',
    'Hybrid',
    'Petrol',
    'Diesel',
];

const seat_numbers = [
    '2',
    '4',
    '5',
    '7+'
];

//Add a color that you'd like to merge into a new color here:
// Example config where  Silver and Grey will be under new heading 'Silver/Gray'

const colorNameChangesConfig = {
    //Example
    // Silver: "Silver/Grey",
    // Grey: "Silver/Grey",
    Silver: "Silver/Grey",
    Grey: "Silver/Grey",
    Yellow: "Yellow",
    Gold: "Yellow",
    Ivory: "White",
    White: "White",
    Snow: "White"
}
//Inverse above Object for easy access later. Ie, above example becomes
// { Silver/Grey: ['Silver', 'Grey']
const inverseNameChangesConfig = Object.entries(colorNameChangesConfig).reduce((acc, [key, value]) => {
    if (!acc[value]) {
        acc[value] = [];
    }
    acc[value].push(key);
    return acc;
}, {});

//Change url here incase of broken formatting
const colorLabelUrl = {
    //Example
    // 'Silver/Grey': 'silver-grey'
    'Silver/Grey': 'silver-grey'

}
//invert for easy access
const invertedColorLabelUrl = Object.fromEntries(
    Object.entries(colorLabelUrl).map(([key, value]) => [value, key])
);

//Change the CSS of Color Buttons here. Default will be CSS
const colourConfig = {
    //Example
    // "Black" :{
    //     backgroundColor: "#1D1D1D1A",
    //     textColor: "Black",
    //     borderColor: "#1D1D1D1A",
    // },
    "Black" :{
        backgroundColor: "#1D1D1D1A",
        textColor: "Black",
        borderColor: "#1D1D1D1A",
    },
    "White" :{
        backgroundColor: "White",
        textColor: "Black",
        borderColor: "#1D1D1D1A",
    },
    "Yellow" :{
        backgroundColor: "Gold",
        textColor: "Black",
        borderColor: "Gold",
    },
    "Blue" :{
        backgroundColor: "rgba(0, 28, 221, 0.1)",
        borderColor: "rgba(0, 28, 221, 0.1)",
        textColor: "#001CDD"
    },
    "Brown" :{
        backgroundColor: "rgba(165, 42, 42, 0.1)",
        borderColor: "rgba(165, 42, 42, 0.1)",
        textColor: "Brown"
    },
    "Green" :{
        backgroundColor: "rgba(120, 147, 122, 0.2)",
        borderColor: "rgba(120, 147, 122, 0.2)",
        textColor: "rgba(120, 147, 122, 1)"
    },
    "Red" :{
        backgroundColor: "rgba(218, 91, 72, 0.1)",
        borderColor: "rgba(218, 91, 72, 0.1)",
        textColor: "rgba(218, 91, 72, 1)"
    },
    "Purple" :{
        backgroundColor: "rgba(75,0,130, 0.1)",
            borderColor: "rgba(75,0,130, 0.1)",
            textColor: "rgba(75,0,130, 1)"
    },
    "Orange" :{
        backgroundColor: "rgba(255,140,0, 0.1)",
        borderColor: "rgba(255,140,0, 0.1)",
        textColor: "rgba(255,140,0, 1)"
    }
};

const colourDefaultConfig = {
    active: false,
    backgroundColor: "White",
    borderColor: "Black"
}

class VehiclesFilters extends Component {
    constructor(props) {
        super(props);

        const savedScrollPos = sessionStorage.getItem('scrollPosition');
        document.documentElement.scrollTop = 0;

        vehicles = this.props.vehicles;
        hideUI = this.props.hideUI;
        models = this.props.models;
        models.forEach((m) => {
            m.value = m.MODEL_SEQ;
            m.label = m.MODEL_NAME;
        });
        vehicles.forEach((v) => {
            const year = v["@LISTING_YEAR"];
            if (years.findIndex((y) => y.label === year) === -1) {
                years.push({ label: year, value: parseInt(year) });
            }
        });

        makes.forEach((m) => {
            m.value = m.MAKE_SEQ;
            m.label = m.MAKE_NAME === "RAM" ? "Ram" : m.MAKE_NAME;
        });
        makes.forEach((m, i, o) => {
            if (parseInt(m.MAKE_SEQ) == 0 && m.MAKE_NAME == "Other") {
                o.splice(i, 1);
            }
        });

        years.sort((a, b) => a.value - b.value).reverse();
        years = [{ value: null, label: "Any" }].concat(years);

        vehicles.forEach((v) => {
            const type = v["@LISTING_FUEL_TYPE"].trim().replace(/,/g, "");
            v.fuelType = type;
        });
        ribbonData = this.props.ribbonData;
        regions = this.props.regions;
        regions.unshift(regionSouthIsland);
        regions.unshift(regionNorthIsland);
        regions.forEach((r) => {

            //Add dealership info
            r.value = r.term_id;
            r.label = r.name;

            let island = null;
            regionIsland.forEach((element) => {

                if(element.region == r.slug){
                    //get island for dealership
                    island = element.island
                }
            });

            for (const key in r.dealerships) {
                const dealership = r.dealerships[key];
                dealership.region_ID = r.term_id;
                dealership.value = dealership.post_name;
                dealership.label = (dealership.post_title);
                dealership.island = island;
                dealerships.push(r.dealerships[key]);
            }
        });

        this.filterHeadRef = React.createRef();
        this.loadMoreRef = React.createRef();
        this.topBarRef = React.createRef();

        this.urlParams = new URLSearchParams((window.location.search));
        this.overlay = Overlay.instance();
        this.overlay.addOnClick(this.closeSidebar);

        const bTypes = { all: false };
        const colours = { };
        const eType = { all: false };
        const carHistory = { }
        const onSale = false;

        bodyTypes.forEach((b) => {
            bTypes[b] = false;
        });

        if(colourTypes.length == 0){
            colourTypes = ["Black","Blue","Brown","Gold","Green","Grey","Orange","Purple","Red","Silver","White","Yellow","Other"];
        }
        colourTypes.forEach((b) => {
            let colourName = b;

            if(colorNameChangesConfig[colourName]){
                colourName = colorNameChangesConfig[colourName];
            }

            let matchingConfigKey = false;
            if(colourConfig[colourName]){
                matchingConfigKey = colourName;
            }

            if (matchingConfigKey) {
                colours[colourName] = {
                    active: false,
                    backgroundColor: colourConfig[matchingConfigKey].backgroundColor ?? colourDefaultConfig['backgroundColor'],
                    borderColor: colourConfig[matchingConfigKey].borderColor ?? colourDefaultConfig['borderColor'],
                    textColor: colourConfig[matchingConfigKey].textColor ?? b
                };
                colourArray.push(colourName);
            } else {
                // Use default values if no match
                colours[colourName] = {
                    ...colourDefaultConfig,
                    textColor: b
                };
                colourArray.push(colourName);
            }
        });
        colourArray = [...new Set(colourArray)];

        const fuelTypes = {};
        fuel_types.forEach((f) => {
            fuelTypes[f] = false;
        });
        const seatNumbers = {};
        seat_numbers.forEach((s) => {
            seatNumbers[s] = false;
        });
        const startingStep = 24;
        const savedShowingState = Number(sessionStorage.getItem('showingState') ?? startingStep);
        this.state = {
            wh: null,
            region: null,
            regionLabel: null,
            dealership: null,
            dealershipLabel: null,
            make: null,
            expressDelivery: null,
            makeLabel: null,
            selectedMakes: [],
            model: null,
            modelLabel: null,
            odometer: {
                from: null,
                to: null,
            },
            year: {
                from: null,
                to: null,
            },
            price: {
                from: null,
                to: null,
            },
            savedUrlString: null,
            bTypes, //type
            colours,
            eType, //emission type
            carHistory,
            fuelTypes,
            onSale: false,
            seatNumbers,
            filters : {
            },
            sort: sortOptions[0].value,
            showing: savedShowingState,
            special: false,
            keywords: "",
            keywordsMakeFlag : false,
            keywordsMakeAdded: [],
            showFilterLoading: true,
            urlArray: [],
            argsArray: [],
            brandHeros: null,
            saveSearchEmail: '',
            saveSearchSaved: false,
            showingSidebarDesktop: !hideUI,
            showingSaveSearch: false,
            firstLoad: true,
            prevScrollPos: savedScrollPos,
        };

        custom_filter_fields.forEach((element) => {
           this.state.filters[element['name']] = false;
        });
        const splitArray = url.split("/");
        this.subUrlArray = splitArray.slice(splitArray.indexOf("our-vehicles")+1, url.length);
        let args = ['make','model','carhistory','type','seats','fuel','sort','emissiontype','region','dealership','express','years','price','odometer','on','special', 'colours', 'filters'];
        let urlArray = new Array(args.length);

        this.subUrlArray.forEach((element)=>{
            let elementName = element.split('-')[0];
            let elementRest = decodeURI(element.replaceAll(elementName+'-',''));

            if(args.includes(elementName.toLowerCase())){
                urlArray[args.indexOf(elementName.toLowerCase())] = decodeURI(elementRest);
            }
        })
        this.state.urlArray = urlArray;
        //check filters first
        if(urlArray[17]){
            this.state = this.checkFilters(urlArray[17],  this.state);
        }

        const match = "{}"
        if(offerFilterDetails){
            this.state =(processFilterOn(offerFilterDetails, this.state, makes, models, regions, dealerships, years));

        }

        this.state.argsArray = args;
        this.setSearchState();
        this.setUrlFormating();
        this.renderBrandBanner();

        this.selectMultiRef = React.createRef();

        this.debouncedUpdateDataLayer = debounce(this.updateDataLayer, 750);
        this.debouncedKeywordSearch = debounce(this.keywordSearch, 250);
        this.debouncedRenderItems = debounce(this.renderItems, 250);
        this.debouncedUpdateKeywords = debounce((value) => {
            this.setState({ keywords: value }, () => {
                this.updateDataLayer();
            });
        }, 250);

        const self = this;
        this.filters = {
            filters: {
                clear() {
                    for(const key in self.state.filters){
                        self.state.filters[key] = false;
                    }
                    self.state.urlArray[17] = null;
                    self.setUrlFormating();
                    self.triggerFilterLoading();
                },

                onInit() {

                },
                crumb() {
                },

                activeCount() {
                    return 0;
                },
            },
            sort: {
                field: {
                    get value() {
                        return self.state.sort;
                    },
                    onChange: ({ value }) => {
                        this.setState({ sort: value }, () => {
                            this.updateDataLayer();
                        });

                        this.state.urlArray[6] = value;
                        this.setUrlFormating();
                        self.triggerFilterLoading();
                    },

                },
                get isApplied() {
                    return (
                        self.state.sort !== null
                    );
                },
                clear() {
                    self.setState({ sort: 'recent' });
                    self.state.urlArray[6] = null;
                    self.setUrlFormating();
                    self.triggerFilterLoading();
                },
                apply(item) {
                    const { sortBy } = self.state.sort;

                    if (sortBy !== null) {
                        return true
                    }


                    return false;
                },
                onInit() {
                    let sortBy = self.urlParams.get("sort");


                    if (sortBy) {
                        self.state.sort = sortBy;
                    }



                },
                crumb() {
                },

                activeCount() {
                    return 0;
                },
            },


            regions: {
                field: {
                    get value() {
                        return self.state.region;
                    },
                    onChange: ({ value, label }) => {
                        if (value !== this.state.region) {
                            this.setState(
                                {
                                    region: value,
                                    dealership: null,
                                    regionLabel: label,
                                    dealershipLabel: "All dealerships",
                                },
                                () => {
                                    this.updateDataLayer();
                                }
                            );

                            this.state.urlArray[8] = label;
                            this.state.urlArray[9] = null
                            this.setUrlFormating();
                            self.triggerFilterLoading();
                        }
                    },
                    get options() {
                        return [this.defaultValue].concat(regions);
                    },
                    defaultValue: { value: null, label: "All regions" },
                },
                get isApplied() {
                    return self.state.region !== null;
                },
                get saveValue() {
                    return self.state.region;
                },
                clear() {
                    self.setState({ region: null });
                    self.state.urlArray[8] = null;
                    self.state.urlArray[9] = null
                    self.setUrlFormating();
                    self.triggerFilterLoading();
                },
                apply(item) {
                    const regionIndex = this.field.options.findIndex(
                        (r) => self.state.region === r.value
                    );

                    // If region is not selected, pass this filter
                    if (regionIndex === -1) return true;

                    const region = this.field.options[regionIndex];

                    // If selected all -> Pass
                    if (region.value === null) return true;

                    //check for north and south island
                    if(self.state.region != north_island_string && self.state.region != south_island_string) {
                        const dealerships = [...Object.values(region.dealerships)];

                        // Return true if found
                        // - in one of the yards &&
                        // - out of one of the dealerships
                        // - out of selected region
                        return dealerships.some((d) =>
                            d.data.autoplay.yards.some(
                                (y) => y.id === item["@BODY_YARD_SEQ"]
                            )
                        );
                    }else{
                        let dealership = 0;
                        dealerships.forEach((d) => {
                            if(d.data.autoplay.yards.some(
                                (y) => y.id === item["@BODY_YARD_SEQ"]
                            )){
                                dealership = d;

                            }

                        })

                        if(dealership != 0){
                            return (dealership.island == self.state.region);
                        }else{
                            return false;
                        }

                    return false;

                    }
                },
                onInit() {
                    let urlParam = self.urlParams.get("region");

                    if (urlParam) {
                        const item = this.field.options.find(
                            (o) => (o.label.toLowerCase()) == urlParam.toLowerCase()
                        );

                        if (typeof item !== "undefined") {
                            self.state.region = item.value;
                            self.state.regionLabel = item.label;
                            this.field.preSelect = {
                                value: item.value,
                                label: item.label,
                            };
                        }
                    }
                },
                crumb() {
                    if (self.state.region !== null) {
                        return self.filterCrumb(self.state.regionLabel, () =>
                            this.clear()
                        );
                    }
                },
                activeCount() {
                    return self.state.region !== null ? 1 : 0;
                },
            },
            dealerships: {
                field: {
                    get value() {
                        return self.state.dealership;
                    },
                    onChange: ({ value, label, name }) => {
                        this.setState(
                            { dealership: value, dealershipLabel: label },
                            () => {
                                this.updateDataLayer();
                            }
                        );
                        this.state.urlArray[9] = value;
                        this.setUrlFormating();
                        self.triggerFilterLoading();
                    },
                    get options() {
                       if(self.state.region == north_island_string || self.state.region == south_island_string){
                           return [this.defaultValue].concat(
                               dealerships.filter(
                                   (d) => d.island === self.state.region
                               )
                           );
                       }else if(self.state.region){
                           return [this.defaultValue].concat(
                               dealerships.filter(
                                   (d) => d.region_ID === self.state.region
                               )
                           );
                       }else{
                           return [this.defaultValue].concat(
                               dealerships);
                       }
                    },
                    defaultValue: { value: null, label: "All dealerships" },

                },
                get isApplied() {
                    return self.state.dealership !== null;
                },
                get saveValue() {
                    const dealershipIndex = this.field.options.findIndex(
                        (d) => self.state.dealership === d.value
                    );
                    // If dealership is not selected, pass this filter
                    if (dealershipIndex === -1) return false;

                    const dealership = this.field.options[dealershipIndex];
                    const autoplayId = dealership?.data?.autoplay?.dealer;
                    return autoplayId;
                    // return self.state.dealership;
                },
                clear() {
                    self.setState({ dealership: null });
                    self.state.urlArray[9] = null;
                    self.setUrlFormating();
                },
                apply(item) {
                    const selectedDealerships = Array.isArray(self.state.dealership)
                        ? self.state.dealership
                        : [self.state.dealership];

                    const matchingDealerships = this.field.options.filter(d =>
                        selectedDealerships.includes(d.value)
                    );

                    if (matchingDealerships.length === 0) return true;

                    if (matchingDealerships.some(d => d.value === null)) return true;

                    return matchingDealerships.some(dealership =>
                        dealership.data.autoplay.yards.some(
                            y => y.id === item["@BODY_YARD_SEQ"]
                        )
                    );
                }
                ,
                onInit() {
                    let urlParam = self.urlParams.get("dealership");

                    if (urlParam) {
                        urlParam = (urlParam);
                        const item = this.field.options.find(
                            (o) => (o.label.toLowerCase()) === urlParam.toLowerCase()
                        );

                        if (typeof item !== "undefined") {
                            self.state.dealership = item.value;
                            self.state.dealershipLabel = item.label;
                            this.field.preSelect = {
                                value: item.value,
                                label: item.label,
                            };
                        }
                    }
                },
                crumb() {
                    if (self.state.dealership !== null) {
                        if (Array.isArray(self.state.dealership)) {
                            return self.state.dealershipLabel.map(label =>
                                self.filterCrumb(label, () => this.clear())
                            );
                        } else {
                            return self.filterCrumb(
                                self.state.dealershipLabel,
                                () => this.clear()
                            );
                        }
                    }
                },

                activeCount() {
                    return self.state.dealership !== null &&
                    self.state.region !== null
                        ? 1
                        : 0;
                },
            },
            makes: {
                field: {
                    get value() {
                        return self.state.make;
                    },
                    onChange: (selectedOption ) => {
                        this.setState({ selectedMakes: selectedOption });
                        let makeLabel = [];
                            let makeValue = [];

                            for (let option of selectedOption) {
                                makeLabel.push(option.label);
                                makeValue.push(option.value);
                            }

                            makeLabel = makeLabel.join(",");
                            makeValue = makeValue.join(",");

                            if(makeLabel == ""){
                                this.setState(
                                    {
                                        make: null,
                                        model: null,
                                        makeLabel: null,
                                        modelLabel: "All models",
                                        keywordsMakeFlag: false,
                                    },
                                    () => {
                                        this.updateDataLayer();
                                    }
                                );
                            }else {
                                this.setState(
                                    {
                                        make: makeValue,
                                        model: null,
                                        makeLabel: makeLabel,
                                        modelLabel: "All models",
                                        keywordsMakeFlag: false,
                                    },
                                    () => {
                                        this.updateDataLayer();
                                    }
                                );
                            }
                            //
                            //
                            this.state.urlArray[0] = makeLabel;
                            this.state.urlArray[1] = null;
                            if(this.state.urlArray[0] == 'All makes'){
                                this.state.urlArray[0] = null;
                            }
                            this.setUrlFormating();
                            self.triggerFilterLoading();


                    },
                    get options() {
                        return makes;
                    },
                },
                get isApplied() {
                    return (self.state.make !== null && self.state.make != "");
                },
                get saveValue() {
                    return self.state.make;
                },
                clear(item) {
                    const { selectedMakes, make, makeLabel, urlArray } = self.state;
                    if (!item) {
                        self.setState({ make: null, makeLabel: null, selectedMakes: [] }, ()=>{
                        });
                        self.state.urlArray[0] = null;
                        self.setUrlFormating();
                        return;
                    }

                    let makesLabelArray = makeLabel.split(',').map(label => label.trim());
                    makesLabelArray = makesLabelArray.filter(label => (label) !== (item));
                    const makesLabelString = makesLabelArray.filter(label => item.trim() !== label).join(',');
                    const makesURLString = makesLabelString == '' ? null : makesLabelString;

                    let makesArray = make.split(',').map(m => m.trim());
                    const found = makes.find(make => make.label === item);
                    const value = found ? found.value : null;
                    makesArray = makesArray.filter(num => Number(num) !== Number(value));


                    let cleanString = makesArray.filter(m => Number(m.replace(/\s+/g, '')) !== Number(item.replace(/\s+/g, ''))).join(',');
                    cleanString = cleanString == '' ? null : cleanString;
                    const cleanedArr = selectedMakes.filter(make => make.label.trim() !== item.trim());
                    // Update state
                    self.setState({ make: cleanString, makeLabel: makesLabelString, selectedMakes: cleanedArr }, ()=>{
                    });
                    self.state.urlArray[0] = makesURLString;
                    self.setUrlFormating();



                },
                apply(item) {
                    if(self.state.make == null || self.state.make == ""){
                        return true;
                    }
                    if(typeof self.state.make == "number"){
                        self.state.make = String(self.state.make);
                    }
                    const makeArray = self.state.make.split(",").map(item => item.trim()).filter(item => item !== "").map(Number);
                    if(makeArray.includes(parseInt(item["@MAKE_SEQ"]))){
                        return true;
                    }

                },
                onInit() {
                    let urlMake = self.urlParams.get("make");

                    if (urlMake) {
                        urlMake = (urlMake);
                        const item = makes.find(
                            (m) => (m["MAKE_NAME"].toLowerCase()) === urlMake.toLowerCase()
                        );

                        if (typeof item !== "undefined") {
                            self.state.make = item.value;
                            self.state.makeLabel = item.label;
                            this.field.preSelect = {
                                value: item.value,
                                label:
                                    item.MAKE_NAME === "RAM"
                                        ? "Ram"
                                        : item.MAKE_NAME,
                            };
                        }
                    }
                },
                crumb() {
                    if (self.state.make !== null){
                        const crumbs = [];
                        const makes = self.state.makeLabel.split(",");
                        for (const item of makes) {
                            // If at least one checked

                            if ( item !== "all") {
                                // console.log(key);
                                crumbs.push(
                                    self.filterCrumb(item, () => this.clear(item))
                                );
                            }
                        }

                        return crumbs;
                    }
                },
                activeCount() {
                    return self.state.make !== null ? 1 : 0;
                },
            },
            models: {
                field: {
                    get value() {
                        return self.state.model;
                    },
                    onChange: ({ value, label }) => {
                        this.setState(
                            { model: value, modelLabel: label },
                            () => {
                                this.updateDataLayer();
                            }
                        );
                        this.state.urlArray[1] = label;
                        if(this.state.urlArray[1] == 'All models'){
                            this.state.urlArray[1] = null;
                        }
                        this.setUrlFormating();
                        self.triggerFilterLoading();
                    },
                    get options() {
                        return [{ value: null, label: "All models" }].concat(
                            models.filter(
                                (m) =>
                                    parseInt(m.MAKE_SEQ) ===
                                    parseInt(self.state.make)
                            )
                        );
                    },
                    defaultValue: { value: null, label: "All models" },
                    get isDisabled() {
                        return (self.state.make === null || self.state.make.includes(','));
                    },
                },
                get isApplied() {
                    return self.state.model !== null;
                },
                get saveValue() {
                    return self.state.model;
                },
                clear() {
                    self.setState({ model: null, modelLabel: "All models" });
                    self.state.urlArray[1] = null;
                    self.setUrlFormating();
                },
                apply(item) {
                    const modelIndex = this.field.options.findIndex(
                        (m) => parseInt(self.state.model) === parseInt(m.value)
                    );

                    // console.log('apply model', self.state.model, this.field.options, modelIndex);
                    // If model is not selected, pass this filter
                    if (modelIndex === -1) return true;

                    const model = this.field.options[modelIndex];

                    // If selected all -> Pass
                    if (model.value === null) return true;

                    return (
                        parseInt(model.value) === parseInt(item["@MODEL_SEQ"])
                    );
                },
                onInit() {
                    let urlModel = self.urlParams.get("model");

                    if (urlModel) {
                        urlModel = (urlModel);
                        const item = models.find(
                            (m) => (m["MODEL_NAME"].toLowerCase()) === urlModel.toLowerCase()
                        );

                        if (typeof item !== "undefined") {
                            self.state.model = item.value;
                            self.state.modelLabel = item.label;
                            this.field.preSelect = {
                                value: item.value,
                                label: item["MODEL_NAME"],
                            };
                        }
                    }
                },
                crumb() {
                    if (self.state.model !== null)
                        return self.filterCrumb(self.state.modelLabel, () =>
                            this.clear()
                        );
                },
                activeCount() {
                    return self.state.model !== null ? 1 : 0;
                },
            },
            odometer: {
                field: {
                    get value() {
                        return self.state.odometer;
                    },
                    onChange: ({ range }) => {
                        this.setState({ odometer: range }, () => {
                            this.updateDataLayer();
                        });

                        this.state.urlArray[13] = range;
                        this.setUrlFormating();
                        self.triggerFilterLoading();
                    },
                    options: odometer,
                },
                get isApplied() {
                    return (
                        self.state.odometer.from !== null ||
                        self.state.odometer.to !== null
                    );
                },
                get saveValue() {
                    return self.state.odometer;
                },
                clear() {
                    self.setState({ odometer: { from: null, to: null } });
                    self.state.urlArray[13] = null;
                    self.setUrlFormating();
                },
                apply(item) {
                    const { from, to } = self.state.odometer;

                    // Fail if less then from
                    if (from !== null) {
                        if (
                            parseInt(item["@LISTING_ODOMETER"]) < parseInt(from)
                        ) {
                            return false;
                        }
                    }

                    // Fail if more then to
                    if (to !== null) {
                        if (
                            parseInt(item["@LISTING_ODOMETER"]) > parseInt(to)
                        ) {
                            return false;
                        }
                    }

                    return true;
                },
                onInit() {
                    let toParam = self.urlParams.get("odometer-to");
                    let fromParam = self.urlParams.get("odometer-from");

                    const range = { to: null, from: null };

                    if (toParam) {
                        const item = odometer.find(
                            (o) => parseInt(o.value) === parseInt(toParam)
                        );

                        if (typeof item !== "undefined") {
                            range.to = toParam;
                            this.field.preSelectTo = item;
                        }
                    }

                    if (fromParam) {
                        const item = odometer.find(
                            (o) => parseInt(o.value) === parseInt(fromParam)
                        );

                        if (typeof item !== "undefined") {
                            range.from = fromParam;
                            this.field.preSelectFrom = item;
                        }
                    }

                    if(toParam & fromParam) {
                        self.state.odometer = range;
                    }
                },
                crumb() {
                    if (self.state.odometer.from !== null) {
                        let str =
                            "From " + self.state.odometer.from / 1000 + "k kms";
                        if (self.state.odometer.to !== null) {
                            str =
                                self.state.odometer.from / 1000 +
                                "k" +
                                " - " +
                                self.state.odometer.to / 1000 +
                                "k kms";
                        }

                        return self.filterCrumb(str, () => this.clear());
                    } else if (self.state.odometer.to !== null) {
                        let str =
                            "Up to " + self.state.odometer.to / 1000 + "k kms";
                        return self.filterCrumb(str, () => this.clear());
                    }
                },

                activeCount() {
                    return self.state.odometer.from !== null ||
                    self.state.odometer.to !== null
                        ? 1
                        : 0;
                },
            },
            year: {
                field: {
                    get value() {
                        return self.state.year;
                    },
                    onChange: ({ range }) => {
                        this.setState({ year: range }, () => {
                            this.updateDataLayer();
                        });
                        this.state.urlArray[11] = range;
                        this.setUrlFormating();
                        self.triggerFilterLoading();
                    },
                    options: years,
                },
                get isApplied() {
                    return (
                        self.state.year.from !== null ||
                        self.state.year.to !== null
                    );
                },
                get saveValue() {
                    return self.state.year;
                },
                clear() {
                    self.setState({ year: { from: null, to: null } });
                    self.state.urlArray[11] = null;
                    self.setUrlFormating();
                },
                apply(item) {
                    const { from, to } = self.state.year;
                    // Fail if less then from
                    if (from !== null) {
                        if (parseInt(item["@LISTING_YEAR"]) < parseInt(from)) {
                            return false;
                        }
                    }

                    // Fail if more then to
                    if (to !== null) {
                        if (parseInt(item["@LISTING_YEAR"]) > parseInt(to)) {
                            return false;
                        }
                    }

                    return true;
                },
                onInit() {
                    let toParam = self.urlParams.get("year-to");
                    let fromParam = self.urlParams.get("year-from");


                    if (toParam) {
                        const item = years.find(
                            (o) => parseInt(o.value) === parseInt(toParam)
                        );

                        if (typeof item !== "undefined") {
                            range.to = toParam;
                            this.field.preSelectTo = item;
                        }
                    }

                    if (fromParam) {
                        const item = years.find(
                            (o) => parseInt(o.value) === parseInt(fromParam)
                        );

                        if (typeof item !== "undefined") {
                            range.from = fromParam;
                            this.field.preSelectFrom = item;
                        }
                    }

                    if(toParam && fromParam){
                    self.state.year = range;}
                },
                crumb() {
                    if (self.state.year.from !== null) {
                        let str = "From " + self.state.year.from;
                        if (self.state.year.to !== null) {
                            str =
                                self.state.year.from +
                                " - " +
                                self.state.year.to;
                        }

                        return self.filterCrumb(str, () => this.clear());
                    } else if (self.state.year.to !== null) {
                        let str = "Up to " + self.state.year.to;
                        return self.filterCrumb(str, () => this.clear());
                    }
                },
                activeCount() {
                    return self.state.year.from !== null ||
                    self.state.year.to !== null
                        ? 1
                        : 0;
                },
            },
            colours: {
                clear(type = false) {
                    const colours = JSON.parse(
                        JSON.stringify(self.state.colours)
                    );

                    for (const key in colours) {
                        if (type) {
                            if (key === type) colours[key]['active'] = false;
                        } else {
                            colours[key]['active'] = false;
                        }
                    }
                    self.state.urlArray[16] = null;
                    self.setState({ colours });
                },

                apply: (item) => {
                    const { colours } = this.state;
                    let pass = true;
                    const colourKeys = Object.keys(colours).filter(colour => colour !== "Other");
                    if(colours['Other']['active']){
                        let isValid = !colourKeys.some(colour => item["@LISTING_COLOUR"].toLowerCase().includes(colour.toLowerCase()));
                       if(isValid && item["@LISTING_COLOUR"] != ""){
                           return isValid;
                       }
                    }
                    for (const key in colours) {
                        const type = colours[key]['active'];
                        // If at least one checked
                        if (type) {
                            pass = false;
                            let containedColorConfig = [key];
                            if(inverseNameChangesConfig[key]){
                                containedColorConfig = inverseNameChangesConfig[key]
                            }
                            if(containedColorConfig.some(color => color.toLowerCase() === item["@LISTING_COLOUR"].toLowerCase())){
                                return true;
                            }
                        }
                    }

                    return pass;
                },

                get isApplied() {
                    const { colours } = self.state;

                    for (const key in colours) {
                        const type = colours[key]['active'];
                        // If at least one checked
                        if (type) return true;
                    }

                    return false;
                },
                get saveValue() {
                    const { colours } = self.state;

                    // We save all the active colour keys as an array.
                    // ["Blue", "Yellow"]
                    let data = [];
                    for (const key in colours) {
                        if (colours[key]['active']) {
                            data.push(key);
                        }
                    }

                    return data;
                },
                onInit() {
                    let urlType = self.urlParams.get("colour");

                    if (urlType) {
                        const types = decodeURIComponent(urlType).split(",");

                        types.forEach((type) => {
                            if (colourArray.findIndex((b) => b === type) !== -1) {
                                self.state.colours[type]['active'] = true;
                            }
                        });
                    }
                },
                crumb() {
                    const { colours } = self.state;
                    const crumbs = [];

                    for (const key in colours) {
                        const type = colours[key]['active'];
                        // If at least one checked

                        if (type && key !== "all") {
                            // console.log(key);
                            crumbs.push(
                                self.filterCrumb(key, () => this.clear(key))
                            );
                        }
                    }

                    return crumbs;
                },

                activeCount() {
                    const { colours } = self.state;
                    let crumbs = 0;

                    for (const key in colours) {
                        const type = colours[key]['active'];
                        // If at least one checked
                        if (type && key !== "all") crumbs++;
                    }

                    return crumbs;
                },
            },

            bTypes: {
                clear(type = false) {
                    const bTypes = JSON.parse(
                        JSON.stringify(self.state.bTypes)
                    );

                    for (const key in bTypes) {
                        if (type) {
                            if (key === type) bTypes[key] = false;
                        } else {
                            bTypes[key] = false;
                        }
                    }
                    self.state.urlArray[3] = null;
                    self.setState({ bTypes });
                },

                apply: (item) => {
                    const { bTypes } = this.state;
                    let pass = true;
                    for (const key in bTypes) {
                        const type = bTypes[key];

                        // If at least one checked
                        if (type) {
                            if (key === "all") return true;

                            // Fail the pass
                            pass = false;

                            // Unless find at least one that matches
                            //Extra catch for RV
                            if((item['@LISTING_BODY_TYPE'] === 'RV' || item['@LISTING_BODY_TYPE'] === 'SUV') && key === 'RV/SUV'){
                                return true;
                            }
                            if (item["@LISTING_BODY_TYPE"] === key) {
                                return true;
                            }
                        }
                    }

                    return pass;
                },

                get isApplied() {
                    const { bTypes } = self.state;

                    for (const key in bTypes) {
                        const type = bTypes[key];
                        // If at least one checked
                        if (type) return true;
                    }

                    return false;
                },
                get saveValue() {
                    const { bTypes } = self.state;

                    let data = [];

                    for (const key in bTypes) {
                        if(bTypes[key]) {
                            // If at least one checked
                            data.push(key);
                        }
                    }

                    return data;
                },
                onInit() {
                    let urlType = self.urlParams.get("type");

                    if (urlType) {
                        const types = decodeURIComponent(urlType).split(",");

                        types.forEach((type) => {
                            if (bodyTypes.findIndex((b) => b === type) !== -1) {
                                self.state.bTypes[type] = true;
                            }
                        });
                    }
                },
                crumb() {
                    const { bTypes } = self.state;
                    const crumbs = [];

                    for (const key in bTypes) {
                        const type = bTypes[key];
                        // If at least one checked

                        if (type && key !== "all") {
                            crumbs.push(
                                self.filterCrumb(key, () => this.clear(key))
                            );
                        }
                    }

                    return crumbs;
                },

                activeCount() {
                    const { bTypes } = self.state;
                    let crumbs = 0;

                    for (const key in bTypes) {
                        const type = bTypes[key];
                        // If at least one checked
                        if (type && key !== "all") crumbs++;
                    }

                    return crumbs;
                },
            },
            carHistory: {
                clear(type = false) {
                    const carHistory = JSON.parse(
                        JSON.stringify(self.state.carHistory)
                    );

                    for (const key in carHistory) {
                        if (type) {
                            if (key === type) carHistory[key] = false;
                        } else {
                            carHistory[key] = false;
                        }
                    }
                    self.state.urlArray[2] = null;
                    self.setUrlFormating();
                    self.setState({carHistory});
                },

                apply: (item) => {
                    const {carHistory} = this.state;
                    let pass = true;

                    for (const key in carHistory) {
                        const type = carHistory[key];

                        // If at least one checked
                        if (type) {
                            pass = false;
                            if (key === "new") {
                                if(item["@LISTING_NEW"] == "True"){
                                    return true;
                                };
                            } if (key === "demonstrator") {
                                if(item["@LISTING_DEMO"] == "True"){
                                    return true;
                                };
                            }
                            if (key === "used"){
                                if(item["@LISTING_NEW"] == "False" &&  item["@LISTING_DEMO"] == "False"){
                                    return true;
                                };
                            }
                        }

                    }

                    return pass;
                },

                get isApplied() {
                    const {carHistory} = self.state;

                    for (const key in carHistory) {
                        const type = carHistory[key];
                        // If at least one checked
                        if (type) return true;
                    }

                    return false;
                },

                get saveValue() {
                    const { carHistory } = self.state;
                    let data = [];

                    for (const key in carHistory) {
                        if (carHistory[key]) {
                            data.push(key);
                        }
                    }

                    return data;
                },

                onInit() {
                    let urlType = self.urlParams.get("car-history");

                    if (urlType) {
                        const types = decodeURIComponent(urlType).split(",");

                        types.forEach((type) => {
                            self.state.carHistory[type] = true;
                        });
                    }
                },
                crumb() {
                    const {carHistory} = self.state;
                    const crumbs = [];

                    for (const key in carHistory) {
                        const type = carHistory[key];
                        // If at least one checked
                        if (type) {
                            crumbs.push(
                                self.filterCrumb(key, () => this.clear(key))
                            );
                        }
                    }

                    return crumbs;
                },
                activeCount() {
                    const {carHistory} = self.state;
                    let crumbs = 0;

                    for (const key in carHistory) {
                        const type = carHistory[key];
                        // If at least one checked
                        if (type && key !== "all") crumbs++;
                    }

                    return crumbs;
                },
            },

            eType: {
                clear(type = false) {
                    const eType = JSON.parse(
                        JSON.stringify(self.state.eType)
                    );

                    for (const key in eType) {
                        if (type) {
                            if (key === type) eType[key] = false;
                        } else {
                            eType[key] = false;
                        }
                    }
                    self.state.urlArray[7] = null;
                    self.setState({ eType });
                },

                apply: (item) => {
                    const { eType } = this.state;
                    let pass = true;
                    for (const key in eType) {
                        const type = eType[key];

                        // If at least one checked
                        if (type) {
                            pass = false;
                            if(item["@LISTING_VIN"] !== ""){
                                if(!(item["@LISTING_CO2"] === '0' && item["@LISTING_FUEL_TYPE"] !== 'Electric')) {
                                    if (key === "neutral emissions") {
                                        if (item["@LISTING_CO2"] < 192 && item["@LISTING_CO2"] > 145) {
                                            return true;
                                        }
                                        ;
                                    }

                                    if (key === "low emissions") {
                                        if (item["@LISTING_CO2"] < 146) {
                                            return true;
                                        }

                                    }
                                }
                            }

                        }
                    }

                    return pass;
                },

                get isApplied() {
                    const { eType } = self.state;

                    for (const key in eType) {
                        const type = eType[key];
                        // If at least one checked
                        if (type) return true;
                    }

                    return false;
                },

                get saveValue() {
                    const { eType } = self.state;

                    let data = [];

                    for (const key in eType) {
                        if (eType[key]) {
                            data.push(key);
                        }
                    }

                    return data;

                },
                onInit() {
                    let urlType = self.urlParams.get("emissiontype");

                    if (urlType) {
                        const types = decodeURIComponent(urlType).split(",");

                        types.forEach((type) => {
                            self.state.eType[type.toLowerCase()] = true;
                        });
                    }

                },
                crumb() {
                    const { eType } = self.state;
                    const crumbs = [];

                    for (const key in eType) {
                        const type = eType[key];
                        // If at least one checked
                        if (type) {
                            crumbs.push(
                                self.filterCrumb(key, () => this.clear(key))
                            );
                        }
                    }

                    return crumbs;
                },

                activeCount() {
                    const { eType } = self.state;
                    let crumbs = 0;

                    for (const key in eType) {
                        const type = eType[key];
                        // If at least one checked
                        if (type && key !== "all") crumbs++;
                    }

                    return crumbs;
                },
            },

            onSale: {
                clear(type = false) {
                    let onSale = JSON.parse(
                        JSON.stringify(self.state.onSale)
                    );

                    onSale = false;
                    self.state.urlArray[14] = null;
                    self.setUrlFormating();
                    self.setState({ onSale });
                },

                apply: (item) => {
                    const { onSale } = this.state;
                    let pass = true;
                    // If at least one checked
                    if (onSale) {
                        pass = false;
                        if(item['@LISTING_PRICE_SPECIAL'] != 0) {
                            return true;
                        }

                    }

                    return pass;
                },

                get isApplied() {


                    const { onSale } = self.state;
                    // If at least one checked
                    if (onSale) return true;


                    return false;
                },
                get saveValue() {
                    return self.state.onSale ? true : undefined;
                },
                onInit() {
                    let urlType = self.urlParams.get("onsale");


                    if (urlType) {

                        self.state.onSale = true;

                        //remove after sort option has been reworked as param
                    }
                },
                crumb() {
                    const { onSale } = self.state;
                    const crumbs = [];
                    // If at least one checked
                    if (onSale == true) {
                        crumbs.push(
                            self.filterCrumb('Vehicles On Sale', () => this.clear('Vehicles On Sale'))
                        );
                    }

                    return crumbs;
                },

                activeCount() {
                    const { onSale } = self.state;
                    let crumbs = 0;


                    if (onSale) crumbs++;

                    return crumbs;
                },
            },


            expressDelivery: {
                clear(type = false) {
                    let expressDelivery = JSON.parse(
                        JSON.stringify(self.state.expressDelivery)
                    );

                    self.state.urlArray[10] = null;
                    self.setUrlFormating();

                    expressDelivery = false;

                    self.setState({ expressDelivery });
                },

                apply: (item) => {
                    const { expressDelivery } = this.state;
                    let pass = true;
                    // If at least one checked
                    if (expressDelivery) {
                        pass = false;

                        const has1hrTriggerText = "driveaway in minutes";
                        const has1hrDelivery =
                            item["@LISTING_COMMENTS"]
                                .toLowerCase()
                                .includes(has1hrTriggerText) ||
                            item["@LISTING_FEATURES"]
                                .toLowerCase()
                                .includes(has1hrTriggerText) ||
                            item?.Listing_Label_Type_List?.LISTING_LABEL_TYPE_NAME == "60 Minute Delivery";

                        if(has1hrDelivery){
                            pass = true;
                        }
                    }

                    return pass;
                },

                get isApplied() {


                    const { expressDelivery } = self.state;
                    // If at least one checked
                    if (expressDelivery) return true;


                    return false;
                },
                get saveValue() {
                    return self.state.expressDelivery ? true : undefined;
                },

                onInit() {
                    let urlType = self.urlParams.get("expressDelivery");


                    if (urlType) {

                        self.state.expressDelivery = true;

                        //remove after sort option has been reworked as param
                    }
                },
                crumb() {
                    const { expressDelivery } = self.state;
                    const crumbs = [];
                    // If at least one checked
                    if (expressDelivery == true) {
                        crumbs.push(
                            self.filterCrumb('Express Delivery', () => this.clear('Express Delivery'))
                        );
                    }

                    return crumbs;
                },

                activeCount() {
                    const { expressDelivery } = self.state;
                    let crumbs = 0;


                    if (expressDelivery) crumbs++;

                    return crumbs;
                },
            },

            price: {
                field: {
                    get value() {
                        return self.state.price;
                    },
                    onChange: ({ range }) => {
                        this.setState({ price: range }, () => {
                            this.updateDataLayer();
                        });
                        this.state.urlArray[12] = range;
                        this.setUrlFormating();
                        self.triggerFilterLoading();
                    },
                    options: prices,
                },
                get isApplied() {
                    return (
                        self.state.price.from !== null ||
                        self.state.price.to !== null
                    );
                },
                get saveValue() {
                    return self.state.price;
                },
                clear() {
                    self.setState({ price: { from: null, to: null } });
                    self.state.urlArray[12] = null;
                    self.setUrlFormating();


                },
                apply(item) {
                    const { from, to } = self.state.price;

                    // Fail if less then from
                    if (from !== null) {
                        if (self.getPrice(item) < parseInt(from)) {
                            return false;
                        }
                    }

                    // Fail if more then to
                    if (to !== null) {
                        if (self.getPrice(item) > parseInt(to)) {
                            if (to === pricePlus) {
                                // If more than "price plus" - i.e. "120k+" - pass
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }

                    return true;
                },
                onInit() {
                    let toParam = self.urlParams.get("price-to");
                    let fromParam = self.urlParams.get("price-from");

                    const range = { to: null, from: null };

                    if (toParam) {
                        const item = prices.find(
                            (o) => parseInt(o.value) === parseInt(toParam)
                        );

                        if (typeof item !== "undefined") {
                            range.to = toParam;
                            this.field.preSelectTo = item;
                        }
                    }

                    if (fromParam) {
                        const item = prices.find(
                            (o) => parseInt(o.value) === parseInt(fromParam)
                        );

                        if (typeof item !== "undefined") {
                            range.from = fromParam;
                            this.field.preSelectFrom = item;
                        }
                    }
                    if(toParam && fromParam){
                    self.state.price = range;}
                },
                crumb() {
                    if (self.state.price.from !== null) {
                        let str = "From $" + self.state.price.from / 1000 + "k";
                        if (self.state.price.to !== null) {
                            str =
                                "$" +
                                self.state.price.from / 1000 +
                                "k" +
                                " - " +
                                "$" +
                                self.state.price.to / 1000 +
                                "k";
                        }

                        return self.filterCrumb(str, () => this.clear());
                    } else if (self.state.price.to !== null) {
                        let str = "Up to $" + self.state.price.to / 1000 + "k";
                        return self.filterCrumb(str, () => this.clear());
                    }
                },

                activeCount() {
                    return self.state.price.from !== null ||
                    self.state.price.to !== null
                        ? 1
                        : 0;
                },
            },

            seatNumbers: {
                clear(type = false) {
                    const seatNumbers = JSON.parse(
                        JSON.stringify(self.state.seatNumbers)
                    );

                    for (const key in seatNumbers) {
                        if (type) {
                            if (key === type) seatNumbers[key] = false;
                        } else {
                            seatNumbers[key] = false;
                        }
                    }
                    self.state.urlArray[4] = null;
                    self.setUrlFormating();
                    self.setState({ seatNumbers });
                },
                apply: (item) => {
                    const { seatNumbers } = this.state;
                    let pass = true;

                    for (const key in seatNumbers) {
                        const type = seatNumbers[key];

                        // If at least one checked
                        if (type) {
                            // Fail the pass
                            pass = false;

                            // Unless find at least one that matches
                            if(key === '7+'){
                                if(item["@LISTING_SEATS"] >= 7){
                                    return true;
                                }
                            }
                            else if (item["@LISTING_SEATS"] == key) {
                                return true;
                            }
                        }
                    }

                    return pass;
                },
                get isApplied() {
                    const { seatNumbers } = self.state;

                    for (const key in seatNumbers) {
                        const type = seatNumbers[key];
                        // If at least one checked
                        if (type) return true;
                    }

                    return false;
                },

                get saveValue() {
                    const { seatNumbers } = self.state;
                    let data = [];

                    for (const key in seatNumbers) {
                        if (seatNumbers[key]) {
                            data.push(key);
                        }
                    }

                    return data;
                },
                crumb() {
                    const { seatNumbers } = self.state;
                    const crumbs = [];

                    for (const key in seatNumbers) {
                        const type = seatNumbers[key];
                        // If at least one checked
                        if (type) {
                            crumbs.push(
                                self.filterCrumb(key, () => this.clear(key))
                            );
                        }
                    }

                    return crumbs;
                },
                activeCount() {
                    const { seatNumbers } = self.state;
                    let crumbs = 0;

                    for (const key in seatNumbers) {
                        const type = seatNumbers[key];
                        // If at least one checked
                        if (type) crumbs++;
                    }

                    return crumbs;
                },
                onInit() {
                    let urlSeats = self.urlParams.get("seats");

                    if (urlSeats) {
                        const types = decodeURIComponent(urlSeats).split(",");

                        types.forEach((type) => {
                            if (
                                seat_numbers.findIndex((b) => b === type) !== -1
                            ) {
                                self.state.seatNumbers[type] = true;
                            }
                        });
                        if(types.includes('7 ')){
                            self.state.seatNumbers['7+'] = true;
                        }
                    }
                },
            },

            fuelTypes: {
                clear(type = false) {
                    const fuelTypes = JSON.parse(
                        JSON.stringify(self.state.fuelTypes)
                    );

                    for (const key in fuelTypes) {
                        if (type) {
                            if (key === type) fuelTypes[key] = false;
                        } else {
                            fuelTypes[key] = false;
                        }
                    }
                    self.state.urlArray[5] = null;
                    self.setUrlFormating();

                    self.setState({ fuelTypes });
                },
                apply: (item) => {
                    const { fuelTypes } = this.state;
                    let pass = true;

                    for (const key in fuelTypes) {
                        const type = fuelTypes[key];

                        // If at least one checked
                        if (type) {
                            // Fail the pass
                            pass = false;

                            // Unless find at least one that matches
                            let itemFuel = item["fuelType"].toLowerCase();
                            if(key == "Petrol"){
                                if (itemFuel.includes("petrol") || itemFuel.includes("91") || itemFuel.includes("95") || itemFuel.startsWith("pe")) {
                                    return true;
                                }
                            }
                            if(key == "Diesel"){
                                if (itemFuel == "diesel" || itemFuel.startsWith("die")) {
                                    return true;
                                }
                            }
                            if(key == "Electric (EV)"){
                                if ((itemFuel.includes("electric") || itemFuel.includes("ev")) && (!itemFuel.includes("hybrid")) && (!itemFuel.includes('plugin'))) {
                                    return true;
                                }
                            }
                            if(key == "Hybrid"){
                                if (itemFuel.includes("hy") && (!itemFuel.includes("plug"))) {
                                    return true;
                                }
                            }
                            if(key == "Plug-in Hybrid"){
                                if (itemFuel.includes("plug")) {
                                    return true;
                                }
                            }
                        }
                    }

                    return pass;
                },
                get isApplied() {
                    const { fuelTypes } = self.state;

                    for (const key in fuelTypes) {
                        const type = fuelTypes[key];
                        // If at least one checked
                        if (type) return true;
                    }

                    return false;
                },

                get saveValue() {
                    const { fuelTypes } = self.state;
                    let data = [];

                    for (const key in fuelTypes) {
                        if (fuelTypes[key]) {
                            data.push(key);
                        }
                    }

                    return data;
                },

                crumb() {
                    const { fuelTypes } = self.state;
                    const crumbs = [];

                    for (const key in fuelTypes) {
                        const type = fuelTypes[key];
                        // If at least one checked
                        if (type) {
                            crumbs.push(
                                self.filterCrumb(key, () => this.clear(key))
                            );
                        }
                    }

                    return crumbs;
                },
                activeCount() {
                    const { fuelTypes } = self.state;
                    let crumbs = 0;

                    for (const key in fuelTypes) {
                        const type = fuelTypes[key];
                        // If at least one checked
                        if (type) crumbs++;
                    }

                    return crumbs;
                },
                onInit() {
                    let urlFuel = self.urlParams.get("fuel");

                    if (urlFuel) {
                        const types = decodeURIComponent(urlFuel).split(",");

                        types.forEach((type) => {
                            if (
                                fuel_types.findIndex((b) => b === type) !== -1
                            ) {
                                self.state.fuelTypes[type] = true;
                            }
                        });
                    }
                },

            },
            special: {
                field: {
                    get checked() {
                        return self.state.special;
                    },
                    onChange: (e) => {
                        this.setState({ special: e.target.checked }, () => {
                            this.updateDataLayer();
                        });
                        this.state.urlArray[15] = !this.state.urlArray[15];
                        this.setUrlFormating();
                        self.triggerFilterLoading();
                    },
                },
                get isApplied() {
                    return self.state.special;
                },
                get value() {
                    return "Special";
                },
                clear() {
                    self.setState({ special: false });
                    self.state.urlArray[15] = null;
                    self.setUrlFormating();

                },
                apply: (item) => {
                    const { special } = this.state;

                    // If unchecked -> pass
                    if (!special) return true;

                    return item["@LISTING_SPECIAL"] === "True";
                },
                crumb() {
                    if (this.isApplied)
                        return self.filterCrumb("Special", this.clear);
                },
                onInit() {
                    let urlSpecial = self.urlParams.get("special");

                    if (urlSpecial) {
                        self.state.special = urlSpecial === "true";
                    }
                },
                activeCount() {
                    return this.isApplied ? 1 : 0;
                },
            },

            keywords: {
                field: {
                    get value() {
                        return self.state.keywords;
                    },
                    onChange: (e) => {
                        this.setState({ keywords: e.target.value }, () => {
                            //this.updateDataLayer()
                            this.debouncedUpdateDataLayer();
                        });
                        const make = this.checkKeywordsForModel(e.target.value);

                        if(make){
                            const exists = this.state.keywordsMakeAdded.some(
                                (item) => item.value == make.value
                            );
                           const keywordsMakeAdded = !exists ? [...this.state.keywordsMakeAdded, make] : this.state.keywordsMakeAdded;

                            this.setState(
                                {
                                    make: make['value'],
                                    selectedMakes: [make],
                                    model: null,
                                    makeLabel: make['label'],
                                    modelLabel: "All models",
                                    keywordsMakeFlag: true,
                                    keywordsMakeAdded: keywordsMakeAdded
                                }
                            );
                        }


                        if(!make && this.state.keywordsMakeFlag){
                            const filteredSelectedMakes = this.state.selectedMakes.filter(
                                (selected) =>
                                    !this.state.keywordsMakeAdded.some(
                                        (keyword) => keyword.value === selected.value
                                    )
                            );
                            // const splitValuesMakeString = filteredSelectedMakes.map(item => item.value).join(',');
                            // const splitValuesLabelString = filteredSelectedMakes.map(item => item.label).join(',');
                            //
                            // console.log(splitValuesMakeString);
                            // console.log(splitValuesLabelString);

                            this.setState(
                                {
                                    make: null,
                                    makeLabel: null,
                                    selectedMakes: [],
                                    keywordsMakeFlag: false,
                                    keywordsMakeAdded: [],
                                }
                            );
                        }


                        insertParam("keywords", e.target.value || null);
                        self.triggerFilterLoading();
                    },
                },
                clear() {
                    self.setState({ keywords: "" });
                    insertParam("keywords", null);
                },
                apply: (item) => {
                    let { keywords } = this.state;
                    keywords = self.removeMatchedKeywords(keywords);
                    keywords = keywords.trim();
                    // Pass if nothing is typed
                    if (keywords.length === 0) return true;

                    let pass = false;

                    pass = this.keywordSearch(item, keywords);

                    return pass;
                },
                get isApplied() {
                    return self.state.keywords !== "";
                },
                get saveValue() {
                    return self.state.keywords;
                },
                crumb() {
                    const formattedCrumb = self.removeMatchedKeywords(self.state.keywords);
                    if (this.isApplied && formattedCrumb != "")
                        return self.filterCrumb(
                            formattedCrumb,
                            this.clear
                        );
                    return null;
                },
                onInit() {
                    let urlKeywords = self.urlParams.get("keywords");

                    if (urlKeywords) {
                        self.state.keywords = urlKeywords;
                    }
                },
                activeCount() {
                    return this.isApplied ? 1 : 0;
                },
            },
        };

        // Run init functions for filter if exists
        //UYSed for applying url params
        for (const key in this.filters) {
            const filter = this.filters[key];

            if (filter.hasOwnProperty("onInit")) {
                filter["onInit"]();
            }
        }
    }

    crumbNum = 0;

    setUrlFormating(){
        if(hideUI){
            return;
        }
        const stateObj = {};
        let arrayChecker = this.state.urlArray;
        let argsChecker = this.state.argsArray;
        let stringAd = "";
        let toTitle = "Our Vehicles | Armstrongs";
        arrayChecker.forEach((element, index) => {
            if(element != null && element != "") {
                //grab make model location adn dealership for title
                if (index == 0 || index == 1 || index == 8 || index == 9) {
                    toTitle = toTitle + " | " + element;
                }
                //odometer
                if (index == 11) {
                    if (typeof element == 'string') {
                        let yearElement = element.split('-');
                        if (yearElement.length == 2) {
                            if (yearElement[0] != 'any' && yearElement[0] != 'any') {
                                stringAd += argsChecker[index] + '-' + yearElement[0] + '-' + yearElement[1] + "/";

                            } else if (yearElement[0] == 'any' && yearElement[1] != 'any') {
                                stringAd += argsChecker[index] + '-' + 'any' + '-' + yearElement[1] + "/";

                            } else if (yearElement[0] != 'any' && yearElement[1] == 'any') {
                                stringAd += argsChecker[index] + '-' + yearElement[0] + '-' + 'any' + "/";
                            }
                        }
                    } else {
                        if (element.from != null && element.to != null) {
                            stringAd += argsChecker[index] + '-' + element.from + '-' + element.to + "/";

                        } else if (element.from == null && element.to != null) {
                            stringAd += argsChecker[index] + '-' + 'any' + '-' + element.to + "/";

                        } else if (element.to == null && element.from != null) {
                            stringAd += argsChecker[index] + '-' + element.from + '-' + 'any' + "/";
                        }
                    }
                } else if (index == 12) {
                    if (typeof element == 'string') {
                        let priceElement = element.split('-');
                        if (priceElement.length == 2) {
                            if (priceElement[0] != 'any' && priceElement[0] != 'any') {
                                stringAd += argsChecker[index] + '-' + priceElement[0] + '-' + priceElement[1] + "/";

                            } else if (priceElement[0] == 'any' && priceElement[1] != 'any') {
                                stringAd += argsChecker[index] + '-' + 'any' + '-' + priceElement[1] + "/";

                            } else if (priceElement[0] != 'any' && priceElement[1] == 'any') {
                                stringAd += argsChecker[index] + '-' + priceElement[0] + '-' + 'any' + "/";
                            }
                        }
                    } else {
                        if (element.from != null && element.to != null) {
                            stringAd += argsChecker[index] + '-' + element.from + '-' + element.to + "/";

                        } else if (element.from == null && element.to != null) {
                            stringAd += argsChecker[index] + '-' + 'any' + '-' + element.to + "/";

                        } else if (element.to == null && element.from != null) {
                            stringAd += argsChecker[index] + '-' + element.from + '-' + 'any' + "/";
                        }
                    }
                } else if (index == 13) {
                    if (typeof element == 'string') {
                        let odoElement = element.split('-');
                        if (odoElement.length == 2) {
                            if (odoElement[0] != 'any' && odoElement[0] != 'any') {
                                stringAd += argsChecker[index] + '-' + odoElement[0] + '-' + odoElement[1] + "/";

                            } else if (odoElement[0] == 'any' && odoElement[1] != 'any') {
                                stringAd += argsChecker[index] + '-' + 'any' + '-' + odoElement[1] + "/";

                            } else if (odoElement[0] != 'any' && odoElement[1] == 'any') {
                                stringAd += argsChecker[index] + '-' + odoElement[0] + '-' + 'any' + "/";
                            }
                        }
                    } else {
                        if (element.from != null && element.to != null) {
                            stringAd += argsChecker[index] + '-' + element.from + '-' + element.to + "/";

                        } else if (element.from == null && element.to != null) {
                            stringAd += argsChecker[index] + '-' + 'any' + '-' + element.to + "/";

                        } else if (element.to == null && element.from != null) {
                            stringAd += argsChecker[index] + '-' + element.from + '-' + 'any' + "/";
                        }
                    }
                } else if (index == 15) {
                    if (element) {
                        stringAd += argsChecker[index];
                    }
                } else if (index == 16) {
                    if (element) {
                        let arr = element.split(',');
                        let colorToUrl = "colours-";
                        arr.forEach(element => {
                            //check for custom url
                            colorToUrl += (colorLabelUrl[element] ?? element) + ",";
                        })
                        if (colorToUrl.endsWith(',')) {
                            colorToUrl = colorToUrl.slice(0, -1);  // Remove the last character (comma)
                        }
                        stringAd += colorToUrl + "/";
                    }

                }else if(index == 17){
                    stringAd += argsChecker[index] + "-" + element + "/";
                }else{
                    if(index == 9){
                        stringAd += argsChecker[index] + "-" + element.replaceAll(' ','-').replaceAll('/','$').replaceAll("'", "").replaceAll("’", "") + "/";
                    }else{
                        stringAd += argsChecker[index] + "-" + element.replaceAll(' ','-').replaceAll('/','$') + "/";
                    }

                }}
            });

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        toTitle = toTitle.replaceAll('-', ' ').replaceAll(',', ' ');
        let keywords = urlParams.get('keywords')
        // if(keywords){
        //     stringAd += '?&keywords='+ keywords;
        // }
        stringAd = stringAd.replaceAll("'", "").replaceAll("’", "");
        stringAd += window.location.search;

        let description = "Browse our online catalogue of vehicles from";
        let descriptionNoMake = "over 16 of the world’s most trusted vehicle brands";
        if(arrayChecker[0] != null){
            description += " " + arrayChecker[0];
        }else{
            description += " " + descriptionNoMake;
        }
        if(arrayChecker[8]){
            description += " from " + arrayChecker[8];
        }
        if(arrayChecker[9]){
            description += ", " + arrayChecker[9];
        }
        description += ". Reserve vehicle now by placing an instant fully refundable $99.99 online deposit.";
        document.description = description;

        document.title = toTitle;

        const metas = Array.from(document.getElementsByTagName('meta'))
        const metaTitle = metas.find((m) => m.attributes[0].nodeValue === 'og:title')
        metaTitle.attributes[1].nodeValue = toTitle;
        const metaDescName = metas.find((m) => m.attributes[0].nodeValue === 'description')
       if(metaDescName) {
           metaDescName.attributes[1].nodeValue = description;
       }
        const metaOGDescName = metas.find((m) => m.attributes[0].nodeValue === 'og:description')
        if(metaOGDescName) {
            metaOGDescName.attributes[1].nodeValue = description;
        }
        stringAd = stringAd
            .toLowerCase()
            .replace(/([?&]keywords=[^ ]*)|[^a-z0-9-_,\/?&]/g, (match, group) => (group ? group : ''))
            .replace(/-+/g, '-');
        this.state.savedUrlString = "/our-vehicles/"+stringAd;

        history.pushState(stateObj, "", "/our-vehicles/"+stringAd);

    }
    setSearchState(){
        let array = this.state.urlArray;
        let searchParams = new URLSearchParams((window.location.search));
        let urlKeywords = searchParams.get("keywords") ?? "";
        let keywordModel = this.checkKeywordsForModel(urlKeywords);
        if(array[0]){
            const makeArray = array[0].split(",");
            makeArray.forEach(make => {
                const item = makes.find(
                    (o) =>
                        (o.label.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_\/]/g, '')) == make.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_\/]/g, ''));
                this.state.selectedMakes.push(item);
            })
            let makeLabel = [];
            let makeValue = [];

            for (let option of this.state.selectedMakes) {
                makeLabel.push(option.label);
                makeValue.push(option.value);
            }

            makeLabel = makeLabel.join(",");
            makeValue = makeValue.join(",");

            this.state.make = makeValue;
            this.state.makeLabel = makeLabel;

        }
        if(keywordModel) {
            const item = makes.find(
                (o) =>
                    (o.label.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_\/]/g, '')) == keywordModel.label.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_\/]/g, ''));
            if (typeof item !== "undefined") {
                let selectMakes = this.state.selectedMakes;
                console.log(selectMakes );
                if(typeof selectMakes != "object"){
                    selectMakes = [];
                }
                selectMakes.push(item);

                this.state.make = item.value;
                this.state.makeLabel = item.label;
                this.state.keywordsMakeFlag = true;
                this.state.selectedMakes = selectMakes;
            }
        }

        if(array[0] && array[1]){
            const item = models.find(
                (o) =>
                    (o.label.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_\/]/g, '')) == array[1].toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_\/]/g, ''));

            if (typeof item !== "undefined") {
                this.state.model = item.value;
                this.state.modelLabel = item.label;
            }
        }
        if(array[2]){
           let types = array[2].split(',');
            types.forEach((type) => {
                this.state.carHistory[type] = true;
            });
        }

        if(array[3]){
            let types = array[3].split(',');
            types.forEach((type) => {
                for (const [key, value] of Object.entries(this.state.bTypes)) {
                    if(key.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_]/g, '')== type.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_]/g, '')){
                        this.state.bTypes[key] = true;
                    }
                }

            });
        }
        if(array[4]){
            let seats = array[4].split(',');
            seats.forEach((type) => {
                for (const [key, value] of Object.entries(this.state.seatNumbers)) {
                    if(key.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '')== type.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '')){
                        this.state.seatNumbers[key] = true;
                    }
                }
            });
        }

        if(array[5]){
            let fuelType = array[5].split(',');
            fuelType.forEach((type) => {
                for (const [key, value] of Object.entries(this.state.fuelTypes)) {
                    if(key.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_]/g, '')== type.toLowerCase().replaceAll(' ', '-').replace(/[^a-zA-Z0-9-_]/g, '')){
                        this.state.fuelTypes[key] = true;
                    }
                }
            });
        }

        if(array[6]){
            let sort = array[6];
            this.state.sort = sort.toLowerCase();
        }
        if(array[7]){
            let emissionType = decodeURI(array[7]).toLowerCase().replaceAll('-',' ').split(',');
            emissionType.forEach((type) => {
                this.state.eType[type] = true;
            });
        }
        if(array[8]){
            let region = array[8].replaceAll('-',' ');
            if (region) {
                const item = regions.find(

                    (o) => (o.label.toLowerCase().replace(/-+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '')) == region.toLowerCase().replace(/-+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '')
                );
                if (typeof item !== "undefined") {
                    this.state.region = item.value;
                    this.state.regionLabel = item.label;
                }
            }
        }
        if(array[9]){
            let dealership = array[9];
            if (dealership) {
                let dealershipArray = dealership.split(",").map(s => s.trim());
                let items = dealerships.filter(o => dealershipArray.includes(o.value));
                items = items.filter((obj, index, self) =>
                    index === self.findIndex(t => t.value === obj.value)
                );
                if (items.length === 0) {
                    this.state.dealership = null;
                    this.state.dealershipLabel = null;
                    this.state.urlArray[9] = null;
                } else if(items.length === 1){
                    this.state.dealership = items[0].value;
                    this.state.dealershipLabel = items[0].label;
                }else{
                    // Store arrays of values and labels
                    this.state.dealership = items.map(o => o.value);
                    this.state.dealershipLabel = items.map(o => o.label);
                }
            }
        }
        if(array[10]){
            this.state.expressDelivery = true;
        }
        if(array[11]){

            let yearInit = array[11].split("-");
            if(yearInit.length === 2) {
                let range = {to: null, from: null};

                if (yearInit[0]) {
                    const item = years.find(
                        (o) => parseInt(o.value) === parseInt(yearInit[0])
                    );

                    if (typeof item !== "undefined") {
                        range.from = item.value;
                    }
                }

                if (yearInit[1]) {
                    const item = years.find(
                        (o) => parseInt(o.value) === parseInt(yearInit[1])
                    );

                    if (typeof item !== "undefined") {
                        range.to = item.value;
                    }
                }

                this.state.year = range;
            }

            }

            if(array[12]) {
                const range = {to: null, from: null};
                let priceInit = array[12].split("-");
                if (priceInit.length === 2) {

                    if (priceInit[1]) {
                        const item = prices.find(
                            (o) => parseInt(o.value) === parseInt(priceInit[1])
                        );

                        if (typeof item !== "undefined") {
                            range.to = item.value;
                        }
                    }

                    if (priceInit[0]) {

                        const item = prices.find(
                            (o) => parseInt(o.value) === parseInt(priceInit[0])
                        );

                        if (typeof item !== "undefined") {
                            range.from = item.value;
                        }
                    }

                    this.state.price = range;
                }
            }

        if(array[13]) {
            const range = {to: null, from: null};
            let odomInit = array[13].split("-");

            if (odomInit[1]) {
                const item = odometer.find(
                    (o) => parseInt(o.value) === parseInt(odomInit[1])
                );

                if (typeof item !== "undefined") {
                    range.to = item.value;
                }else{
                    range.to = odometer[0].value;
                }
            }

            if (odomInit[0]) {
                const item = odometer.find(
                    (o) => parseInt(o.value) === parseInt(odomInit[0])
                );

                if (typeof item !== "undefined") {
                    range.from = item.value;
                }else{
                    range.from = odometer[0].value;
                }
            }

            this.state.odometer = range;

        }

        if(array[14]){
            this.state.onSale = true;
        }
        if(array[15]){
            this.state.special = true;
        }
        if(array[16]){
            let types = array[16].split(',');
            types.forEach((type) => {
                let colorUrlName = (invertedColorLabelUrl[type] ?? type);
                colorUrlName = colorUrlName.charAt(0).toUpperCase() + colorUrlName.slice(1);
                if (this.state.colours[colorUrlName]) {
                    this.state.colours[colorUrlName]['active'] = true;
                }
            });
        }

    }

    filterCrumb = (val, clear) => {
        let valFix = val.replace("Armstrongs","Armstrong's");
        return (
            <div
                key={"crumb-" + val + this.crumbNum++}
                className={"vehicles-filters__crumb"}
                onClick={() => {
                    clear();
                    //if last remove safe search box
                    if(this.renderCount() == 1 && this.state.showingSaveSearch) {
                        this.toggleSaveSearch();
                    };
                }}
            >
                <div className={"vehicles-filters__crumb__close"}></div>
                {valFix}
            </div>
        );
    };


    renderHero = () => {
        const { make } = this.state;
        const makeSelected = makes.find(
            (m) => parseInt(m["MAKE_SEQ"]) === parseInt(make)
        );

        let hero = null;

        if (hero_deal && hero_deal.heading) {
            hero = (
                <HeroDeal
                    heading={hero_deal.heading}
                    content={hero_deal.content}
                    button={{
                        title: hero_deal.link.title,
                        link: hero_deal.link.url,
                    }}
                    src={hero_deal.image.url}
                />
            );
        }

        if (makeSelected) {
            let brandHero = window.brandHeros_data.filter((brand) => {
                return parseInt(brand.make_seq) === makeSelected.MAKE_SEQ;
            });

            if (brandHero.length >= 1) {
                brandHero = brandHero[0];

                if (brandHero.banner && brandHero.banner.image) {
                    // Confirm length is actually > 1 incase data = ""
                    let heroSrc =
                        brandHero.banner.image.length > 1
                            ? brandHero.banner.image
                            : "/images/placeholder/hero.jpg";

                    hero = (
                        <VehicleBrandHero
                            button={{
                                title:
                                    brandHero.banner.link.title ??
                                    `More about ${makeSelected["MAKE_NAME"]}`,
                                link: brandHero.banner.link.url ?? "#",
                            }}
                            src={heroSrc}
                        />
                    );
                }
            }
        }

        return hero;
    };
    renderBrandBanner(){
        const { make } = this.state;
        const makeSelected = makes.find(
            (m) => parseInt(m["MAKE_SEQ"]) === parseInt(make)
        );
        let brandHero = false;
        if(makeSelected){
            brandHero = window.brandHeros_data.filter((brand) => {
                return parseInt(brand.make_seq) === makeSelected.MAKE_SEQ;
            })[0];
        }
        let hero = null;
        let makeBrand = (brandHeros_data).find((element) => parseInt(element['make_seq']) == parseInt(make));
        let headingString = "";
        if(this.state.urlArray[0] || this.state.urlArray[1] != 'All-models' || this.state.urlArray[2] || this.state.urlArray[8]) {
            if (this.state.urlArray[2]) {
                let types = this.state.urlArray[2].split(',');
                types.forEach((type) => {
                    headingString = headingString.concat(type.charAt(0).toUpperCase() + type.slice(1), " ");
                });
            }
            if (this.state.urlArray[0]) {
                headingString = headingString + this.state.urlArray[0] + " ";
            }
            if (this.state.urlArray[1]) {
                headingString = headingString + this.state.urlArray[1] + " ";
            }
            headingString = headingString + "Vehicles ";
            if(this.state.urlArray[14]){
                headingString = headingString + "On Sale ";
            }
            if (this.state.urlArray[8]) {
                headingString = headingString + "in " + this.state.urlArray[8];
            }
        }else if (hero_deal && hero_deal.heading) {
            headingString = brand_banner.heading;
        }else{
            headingString = "Our Vehicles";
        }

        headingString = headingString.replace("-", " ").replace(/\b\w/g, function(char){
            return char.toUpperCase();
        }).replace('Mercedes Benz', 'Mercedes-Benz');



        if(window.location.pathname == '/our-vehicles/sort-savings/on-sale/' && on_sale_banner && on_sale_banner.heading){
            hero = (<VehicleBrandHero
                button={{
                    title: `${on_sale_banner.link.title}`,
                    link: `${on_sale_banner.link.url}`,
                }}
                heading={`${on_sale_banner.heading ? on_sale_banner.heading : headingString}`}
                src={`${on_sale_banner.image.url}`}
                text={`${on_sale_banner.content}`}

            />)
        }else if(makeBrand != null && makeBrand != '' && (brandHero.banner.link) ) {
            hero = (
                <VehicleBrandHero
                    button={{
                        title: brandHero.banner.link.title ? brandHero.banner.link.title : `More about ${makeBrand['name']}`,
                        link: brandHero.banner.link.url ? brandHero.banner.link.url : `/our-brands/${makeBrand['slug']}`,
                    }}
                    heading={headingString}
                    text={`${makeBrand['hero'].branddesc}`}
                    src={ brandHero.banner.image ? brandHero.banner.image : makeBrand['hero']['bg'] }
                />)
        }
        else if(makeBrand != null && makeBrand != '') {
           hero = (
               <VehicleBrandHero
               button={{
                   title: `More about ${makeBrand['name']}`,
                   link: `/our-brands/${makeBrand['slug']}`,
               }}
               heading={headingString}
               text={`${makeBrand['hero'].branddesc}`}
               src={`${makeBrand['hero']['bg']}`}
           />)
       }else if (brand_banner && brand_banner.heading) {
           hero = (<VehicleBrandHero
               button={{
                   title: `${brand_banner.link.title}`,
                   link: `${brand_banner.link.url}`,
               }}
               heading={`${brand_banner.heading ? brand_banner.heading : headingString}`}
               src={`${brand_banner.image.url}`}
               text={`${brand_banner.content}`}

           />)
       }

        return hero;
    }
    renderCount() {
        let count = 0;

        for (let prop in this.filters) {
            count += this.filters[prop].activeCount();
        }
        return count;
    }
    renderCrumbs() {
        const crumbs = [];

        for (let prop in this.filters) {
            const crumble = [].concat(this.filters[prop].crumb());

            crumbs.push(crumble);
        }
        return crumbs;
    }

    // componentDidUpdate() {

    // }

     componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        window.addEventListener("load", this.handleResize);
        window.addEventListener("scroll", ()=> { this.handleScroll()});
        this.handleResize();
        this.scrollOnFirstLoad();
    }

    scrollOnFirstLoad(){
        if (this.state.firstLoad == true) {
            if (this.state.prevScrollPos !== null) {
                // If there's no saved showing state, just set the scroll position
                document.documentElement.scrollTop = Number(this.state.prevScrollPos);
                this.setState({firstLoad: false});
            }

        }
    }


    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleLazyLoadVehicles);
    }

    handleScroll(){
        const scrollTopPos = document.documentElement.scrollTop;
        sessionStorage.setItem('scrollPosition', scrollTopPos);
        this.handleLazyLoadVehicles();

    }
    handleLazyLoadVehicles = () => {
        const element = this.loadMoreRef.current;
        if (this.isElementInViewport(element)) {
            this.showMore();
        }
    };

    isElementInViewport = (el) => {
        if (!el) return false; // Ensure element exists
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };


    keywordSearch(item, keywords) {
        let pass = false;
        const words = keywords.split(/\s+/);

        const checks = [
            // item['@BODY_YARD_CITY'],
            // item['@BODY_YARD_NAME'],
            // item['@LISTING_MODEL'],
            // item['@LISTING_MAKE'],
            item["@LISTING_FEATURES"],
            item["@LISTING_COMMENTS"],
            `${item["@LISTING_MAKE"]} ${item["@LISTING_MODEL"]}`,
        ];

        const partialChecks = [
            `${item["@LISTING_MODEL"]} ${item["@LISTING_VARIANT"]}`,
        ];

        if (words.length > 1) {
            let keywordRegexes = [];
            let attempts = [];

            words.forEach((word) => {
                keywordRegexes.push(
                    new RegExp(`(\\b${word.toLowerCase()}\\b)`)
                );
            });

            keywordRegexes.forEach((regExp) => {
                let passed = false;
                if (checks.some((val) => regExp.test(val.toLowerCase()))) {
                    passed = true;
                }

                attempts.push(passed);
            });

            if (attempts.every((val) => val === true)) {
                pass = true;
            }

            if (attempts.some((val) => val === true)) {
                words.forEach((word) => {
                    // Return true ponly if found the word
                    if (
                        partialChecks.some(
                            (check) =>
                                check
                                    .toLowerCase()
                                    .indexOf(word.toLowerCase()) !== -1
                        )
                    ) {
                        pass = true;
                    }
                });
            }
        } else {
            // OG case , single keyword search
            words.forEach((word) => {
                // Return true ponly if found the word
                if (
                    checks.some(
                        (check) =>
                            check.toLowerCase().indexOf(word.toLowerCase()) !==
                            -1
                    )
                ) {
                    pass = true;
                }

                if (
                    item["@LISTING_STOCK_NO"]?.toLowerCase().includes(word.toLowerCase())
                ) {
                    pass = true;
                }
                if (
                    item["@LISTING_PLATE"]?.toLowerCase().includes(word.toLowerCase())
                ) {
                    pass = true;
                }
            });
        }

        return pass;
    }

    getColorStyling(b){
        const backgroundColor = this.state.colours[b]['backgroundColor'] ?? "White";
        const borderColor = this.state.colours[b]['borderColor'] ?? "Black";
        const textColor = this.state.colours[b]['textColor'] ?? "Black";
           let styling = "<p class='checkbox__colours-filter' " +
               "style='" +
               "border: 1px solid " + borderColor + "; " +
               "color:" + textColor + ";" +
               "background:" + backgroundColor + ";" +
               "padding: 5px 10px;'>" +
            b +
            "</p>"
            return styling;
    }
    updateDataLayer() {
        let layer = {
            event: "filterVehicleSearch",
            filterRegion: this.state.regionLabel ?? "All regions",
            filterDealership: this.state.dealershipLabel ?? "All dealerships",
            filterMake: this.state.makeLabel ?? "All makes",
            filterModel: this.state.modelLabel ?? "All models",
            filterBodyType: this.state.bTypes,
            filterPrice1: this.state.price.from ? this.state.price.from : null,
            filterPrice2: this.state.price.to ? this.state.price.to : null,
            filterOdometerFrom: this.state.odometer.from
                ? this.state.odometer.from
                : null,
            filterOdometerTo: this.state.odometer.to
                ? this.state.odometer.to
                : null,
            filterYearFrom: this.state.year.from ? this.state.year.from : null,
            filterYearTo: this.state.year.to ? this.state.year.to : null,
            filterSpecialOffers: this.state.special,
            filterFuelType: this.state.fuelTypes,
            filterKeywords: this.state.keywords,
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(layer);
    }

    renderFilters = () => {
        return (
            <div className="vehicles-filters__filters">
                <div className="vehicles-filters__expansion">
                    <div className="vehicles-filters__expansion  hide-display-desktop">
                        <Expansion label="Search" isOpen={true}>
                            <span className={`vehicles-filters__keyword-search`}>
                                  <Input
                                      {...this.filters.keywords.field}
                                      name={`keywords`}
                                      modifiers={["filter", "search"]}
                                      placeholder={`Keyword search`}
                                  />
                            </span>
                        </Expansion>
                    </div>
                    <Expansion label="Vehicle Details" isOpen={true}>
                        <div className="vehicles-filters__field">
                            <SelectMultiFilters
                                {...this.filters.makes.field}
                                placeholder={"All makes"}
                                placeholderName={"Makes"}
                                modifiers={["filter"]}
                                preSelect={false}
                                value={this.state.selectedMakes}
                                ref={this.selectMultiRef}
                            />
                        </div>
                        <div className="vehicles-filters__field">
                            <Select
                                {...this.filters.models.field}
                                modifiers={["filter"]}
                            />
                        </div>
                        <div className="vehicles-filters__field">
                            <Checkbox
                                label={{text: `New`}}
                                name={`newcar`}
                                checked={this.state.carHistory['new']}
                                onChange={(e) => {
                                    this.triggerFilterLoading();

                                    const carHistory = JSON.parse(
                                        JSON.stringify(
                                            this.state.carHistory
                                        )
                                    );
                                    carHistory['new'] = e.target.checked;
                                    carHistory["all"] = false;
                                    this.setState({carHistory}, () => {
                                        this.updateDataLayer();
                                    });

                                    const types = [];
                                    for (const key in carHistory) {
                                        const type = carHistory[key];
                                        if (type) types.push(key);
                                    }


                                    this.state.urlArray[2] = types.join(",");
                                    this.setUrlFormating();
                                }}
                            />
                        </div>

                        <div className="vehicles-filters__field">
                            <Checkbox
                                label={{text: `Demonstrator`}}
                                name={`demonstratorcar`}
                                checked={this.state.carHistory['demonstrator']}
                                onChange={(e) => {
                                    this.triggerFilterLoading();

                                    const carHistory = JSON.parse(
                                        JSON.stringify(
                                            this.state.carHistory
                                        )
                                    );
                                    carHistory['demonstrator'] = e.target.checked;
                                    carHistory["all"] = false;
                                    this.setState({carHistory}, () => {
                                        this.updateDataLayer();
                                    });

                                    const types = [];
                                    for (const key in carHistory) {
                                        const type = carHistory[key];
                                        if (type) types.push(key);
                                    }

                                    this.state.urlArray[2] = types.join(",");
                                    this.setUrlFormating();
                                }}
                            />
                        </div>

                        <div className="vehicles-filters__field">
                            <Checkbox
                                label={{text: `Used`}}
                                name={`preownedcar`}
                                checked={this.state.carHistory['used']}
                                onChange={(e) => {
                                    this.triggerFilterLoading();

                                    const carHistory = JSON.parse(
                                        JSON.stringify(
                                            this.state.carHistory
                                        )
                                    );
                                    carHistory['used'] = e.target.checked;
                                    carHistory["all"] = false;
                                    this.setState({carHistory}, () => {
                                        this.updateDataLayer();
                                    });

                                    const types = [];
                                    for (const key in carHistory) {
                                        const type = carHistory[key];
                                        if (type) types.push(key);
                                    }

                                    this.state.urlArray[2] = types.join(",");
                                    this.setUrlFormating();
                                }}
                            />
                        </div>


                    </Expansion>
                </div>
                <div className="vehicles-filters__expansion">
                    <Expansion label="Location" isOpen={true}>
                        <div className="vehicles-filters__field">
                            <Select
                                {...this.filters.regions.field}
                                modifiers={["filter"]}
                            />
                        </div>
                        <div className="vehicles-filters__field">
                            <Select
                                {...this.filters.dealerships.field}
                                modifiers={["filter"]}
                            />
                        </div>
                        <div className="vehicles-filters__field">
                            <Checkbox
                                label={{text: `Express Delivery`}}
                                name={`expressdelivery`}
                                checked={this.state.expressDelivery}
                                onChange={(e) => {
                                    if (this.state.expressDelivery === true) {
                                        this.state.urlArray[10] = null;
                                        this.setState({expressDelivery: false});

                                    } else {
                                        this.state.urlArray[10] = 'delivery';
                                        this.setState({expressDelivery: true});
                                    }

                                    this.triggerFilterLoading();
                                    this.setUrlFormating();
                                }}
                            />
                        </div>
                    </Expansion>
                </div>
                <div className="vehicles-filters__expansion">
                    <Expansion label="Year" isOpen={true}>
                        <div className="vehicles-filters__field vehicles-filters__field--range">
                            <Range
                                {...this.filters.year.field}
                                name="year"
                                type="select"
                                label={{text: "Year:"}}
                            />
                        </div>
                    </Expansion>
                </div>
                <div className="vehicles-filters__expansion">
                    <Expansion label="Price" isOpen={true}>
                        <div className="vehicles-filters__field vehicles-filters__field--range">
                            <Range
                                {...this.filters.price.field}
                                name="price"
                                type="select"
                                label={{text: "Price:"}}
                            />
                        </div>

                    </Expansion>
                </div>

                <div className="vehicles-filters__expansion">
                    <Expansion label="Body Type" isOpen={false}>
                        <div className="vehicles-filters__field">
                            <Checkbox
                                label={{text: "All body types"}}
                                name={`body_style_all`}
                                checked={this.state.bTypes["all"]}
                                onChange={(e) => {
                                    this.triggerFilterLoading();

                                    const colours = JSON.parse(
                                        JSON.stringify(this.state.colours)
                                    );

                                    // Disable all types if clicked all
                                    for (const key in colours) {
                                        colours[key]['active'] = false;
                                    }

                                    this.setState({colours});

                                    this.state.urlArray[3] = null;
                                    this.setUrlFormating();
                                }}
                            />
                        </div>
                        {bodyTypes.map((b, index) => {
                            return (
                                <div
                                    className="vehicles-filters__field"
                                    key={index}
                                >
                                    <Checkbox
                                        label={{text: b}}
                                        name={`body_style_${index}`}
                                        checked={this.state.bTypes[b]}
                                        onChange={(e) => {
                                            this.triggerFilterLoading();

                                            const bTypes = JSON.parse(
                                                JSON.stringify(
                                                    this.state.bTypes
                                                )
                                            );
                                            bTypes[b] = e.target.checked;
                                            bTypes["all"] = false;
                                            this.setState({bTypes}, () => {
                                                this.updateDataLayer();
                                            });

                                            const types = [];
                                            for (const key in bTypes) {
                                                const type = bTypes[key];
                                                if (type) types.push(key);
                                            }

                                            this.state.urlArray[3] = types.join(",");
                                            this.setUrlFormating();
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </Expansion>
                </div>

                <div className="vehicles-filters__expansion">
                    <Expansion label="Fuel Type" isOpen={false}>
                        {fuel_types.map((f, index) => {
                            return (
                                <div
                                    className="vehicles-filters__field"
                                    key={index}
                                >
                                    <Checkbox
                                        label={{text: f}}
                                        name={`fuel_type_${index}`}
                                        checked={this.state.fuelTypes[f]}
                                        onChange={(e) => {
                                            this.triggerFilterLoading();
                                            const fuelTypes = JSON.parse(
                                                JSON.stringify(
                                                    this.state.fuelTypes
                                                )
                                            );
                                            fuelTypes[f] = e.target.checked;
                                            this.setState({fuelTypes});

                                            const types = [];
                                            for (const key in fuelTypes) {
                                                let type = fuelTypes[key];
                                                if (key == 'Electric-(EV)') {
                                                    type = fuelTypes['Electric (EV)'];

                                                }
                                                if (type) types.push(key);
                                            }

                                            this.state.urlArray[5] = types.join(",");
                                            this.setUrlFormating();
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </Expansion>
                </div>
                <div className="vehicles-filters__expansion">
                    <Expansion label="Odometer" isOpen={false}>
                        <div className="vehicles-filters__field vehicles-filters__field--range">
                            <Range
                                {...this.filters.odometer.field}
                                name="odometer"
                                type="select"
                                label={{text: "Odometer (km):"}}
                            />
                        </div>
                    </Expansion>
                </div>


                <div className="vehicles-filters__expansion">
                    <Expansion label="Seats" isOpen={false}>
                        {seat_numbers.map((f, index) => {
                            return (
                                <div
                                    className="vehicles-filters__field"
                                    key={index}
                                >
                                    <Checkbox
                                        label={{text: f}}
                                        name={`seat_numbers_${index}`}
                                        checked={this.state.seatNumbers[f]}
                                        onChange={(e) => {
                                            this.triggerFilterLoading();
                                            const seatNumbers = JSON.parse(
                                                JSON.stringify(
                                                    this.state.seatNumbers
                                                )
                                            );
                                            seatNumbers[f] = e.target.checked;
                                            this.setState({seatNumbers});

                                            const types = [];
                                            for (const key in seatNumbers) {
                                                const type = seatNumbers[key];
                                                if (type) types.push(key);
                                            }

                                            this.state.urlArray[4] = types.join(",");
                                            this.setUrlFormating();
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </Expansion>
                </div>

                <div className="vehicles-filters__expansion">
                    <Expansion label="Colours" isOpen={false}>
                        <div className="vehicles-filters__field">

                            {colourArray.map((b, index) => {
                                return (
                                    <div
                                        className="vehicles-filters__field"
                                        key={index}
                                    >
                                        <Checkbox
                                            label={{
                                                text:
                                                    this.getColorStyling(b)
                                            }}
                                            labelStyle={{color: b}}
                                            name={`colours_${index}`}
                                            checked={this.state.colours[b]['active']}
                                            onChange={(e) => {
                                                this.triggerFilterLoading();

                                                const colours = JSON.parse(
                                                    JSON.stringify(
                                                        this.state.colours
                                                    )
                                                );
                                                colours[b]['active'] = e.target.checked;
                                                this.setState({colours}, () => {
                                                    this.updateDataLayer();
                                                });

                                                const types = [];
                                                for (const key in colours) {
                                                    const type = colours[key]['active'];
                                                    if (type) types.push(key);
                                                }

                                                this.state.urlArray[16] = types.join(",");
                                                this.setUrlFormating();
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </Expansion>
                </div>
                <div className="vehicles-filters__expansion">
                    <Expansion label="More Details" isOpen={false}>
                        {/* <Range
                            {...this.filters.price.field}
                            name="price"
                            type="price"
                        /> */}
                        <div
                            className="vehicles-filters__field"
                        >

                            <div
                                className="vehicles-filters__field"
                            >
                                <Checkbox
                                    label={{text: `Low Emissions`}}
                                    name={`lowemissions`}
                                    checked={this.state.eType['low emissions']}
                                    onChange={(e) => {
                                        this.triggerFilterLoading();

                                        const eType = JSON.parse(
                                            JSON.stringify(
                                                this.state.eType
                                            )
                                        );
                                        eType['low emissions'] = e.target.checked;
                                        eType["all"] = false;
                                        this.setState({eType}, () => {
                                            this.updateDataLayer();
                                        });

                                        const types = [];
                                        for (const key in eType) {
                                            const type = eType[key];
                                            if (type) types.push(key);
                                        }

                                        this.state.urlArray[7] = types.join(",");
                                        this.setUrlFormating();
                                    }}
                                />
                            </div>

                            <div
                                className="vehicles-filters__field"
                            >
                                <Checkbox
                                    label={{text: `Neutral Emissions`}}
                                    name={`neutralemissions`}
                                    checked={this.state.eType['neutral emissions']}
                                    onChange={(e) => {
                                        this.triggerFilterLoading();

                                        const eType = JSON.parse(
                                            JSON.stringify(
                                                this.state.eType
                                            )
                                        );
                                        eType['neutral emissions'] = e.target.checked;
                                        eType["all"] = false;
                                        this.setState({eType}, () => {
                                            this.updateDataLayer();
                                        });

                                        const types = [];
                                        for (const key in eType) {
                                            const type = eType[key];
                                            if (type) types.push(key);
                                        }

                                        this.state.urlArray[7] = types.join(",");
                                        this.setUrlFormating();
                                    }}
                                />
                            </div>
                        </div>

                        <div className="vehicles-filters__field vehicles-filters__field--range">

                            <Checkbox
                                label={{text: `Vehicles on sale`}}
                                name={`onsale`}
                                checked={this.state.onSale}
                                onChange={(e) => {
                                    if (this.state.onSale !== true) {
                                        this.setState({sort: 'savings'});
                                        this.state.urlArray[6] = 'savings';
                                        this.setUrlFormating();
                                    }

                                    this.triggerFilterLoading();

                                    this.state.onSale = e.target.checked;

                                    if (this.state.onSale) {
                                        this.state.urlArray[14] = 'sale';
                                        this.setUrlFormating();
                                    } else {
                                        this.state.urlArray[14] = null;
                                        this.setUrlFormating();
                                    }
                                }}
                            />
                        </div>
                    </Expansion>
                </div>

                {window.current_deal ? (
                    <div className="vehicles-filters__expansion">
                        <Expansion label="Special Offers" isOpen={false}>
                            <div className="vehicles-filters__field">
                                <Checkbox
                                    {...this.filters.special.field}
                                    label={{text: window.current_deal}}
                                    name={`special`}
                                />
                            </div>
                        </Expansion>
                    </div>
                ) : null}
            </div>
        );
    };

    checkKeywordsForModel(keywords){
        const keywordsSplit = keywords.toLowerCase().split(' ');
        for (let make of makes) {
            const makeLabel = make.label.toLowerCase();
            const labelWords = makeLabel.split(' ');
            const matches = labelWords.every(labelWord => keywordsSplit.includes(labelWord));
            if (matches) {
                return make;
            }
        }
        return false;

    }
    removeMatchedKeywords(string) {
        let words = string.toLowerCase().split(' ');

        if (this.state.makeLabel != null) {
            const makeLabel = this.state.makeLabel.toLowerCase();

            words = words.filter(word => word !== makeLabel);
        }

        return words.join(' ');
    }

    triggerFilterLoading = () => {
        this.setState({showFilterLoading: true});

        setTimeout(() => {
            this.setState({showFilterLoading: false});
        }, 1000);
    };

    getPrice = (item) => {
        const isSpecial = item["@LISTING_SPECIAL"] === "True";

        const special = item["@LISTING_PRICE_SPECIAL"];
        const normal = item["@LISTING_PRICE"];
        const value = special > 0 ? special : normal;
        return parseInt(value);
    };

    getSortPrice = (item) => {
        const id = item["@LISTING_SEQ"];
        const isSpecial = item["@LISTING_SPECIAL"] === "True";

        const special = parseInt(item["@LISTING_PRICE_SPECIAL"]);
        const normal = parseInt(item["@LISTING_PRICE"]);
        const display = item["@LISTING_PRICE_DISPLAY"];

        let value = 0;

        if (!isNaN(special) && special > 0) {
            value = special;
        } else {
            value = normal;
        }

        if (value === 0) {
            value = normal;
        }

        return parseInt(value);
    };

    renderMakes = () => {
        const makeItems = [];

        makes.forEach(function (make) {
            const makeItem = {
                MAKE_NAME: make["MAKE_NAME"],
                MAKE_SEQ: make["MAKE_SEQ"]
            }
            makeItems.push(makeItem);
        });

        return makeItems.map((item, i) => {

            return (

                <div class={`col-md-3 col-6`}>
                    <a class="tile__interest-pw"
                       href={`/our-vehicles/make-${item["MAKE_NAME"].replaceAll(' ', '-')}/`}>{item["MAKE_NAME"]}</a>
                </div>
            );
        });


    }

    sortVehicleListByDate = (vehicles) => {
       return vehicles.sort((a, b) => {
            return new moment(b["@Created"].split('.').join(""), "MM/DD/YYYY hh:mm:ss a").diff(new moment(a["@Created"].split('.').join(""), "MM/DD/YYYY hh:mm:ss a"));
        });
    }

    //sortVehicles(this.state, vehicles,this.filters)

    renderItems = (items) => {
        const {sort} = this.state;

        return items.map((item, i) => {
            let hasSlider = true;
            let vehicleId = item["@LISTING_SEQ"];
            let isReserved = !!reservedVehicles[vehicleId];

            return (
                <div className="vehicles-filters__item" key={i}>
                    <Tile {...item} hasSlider isReserved={isReserved} regions={regions} ribbonData={ribbonData}/>
                </div>
            );
        });
    };

    showMore = () => {
        const { showing } = this.state;
        sessionStorage.setItem('showingState', showing + showingStep);

        this.setState({ showing: showing + showingStep });
    };

    /**
     * Toggles the save search.
     *
     * Flips the showingSaveSearch state property and resets the searchSaved
     * state.
     */
    toggleSaveSearch = () => {
        this.setState(prevState => ({
            showingSaveSearch: !prevState.showingSaveSearch,
            // The save search container is being toggled, reset the saves sate
            // as the user is interacting with it again.
            saveSearchSaved: false,
        }))
    };

    /**
     * Saves the search filter.
     *
     * Saves the currently configured filters, along with an email entered by
     * the user.
     */
    saveSearch = (vehicles) => {
        vehicles = this.sortVehicleListByDate(vehicles);
        const recentVehicle = vehicles[0] ?? false;
        let data = {};
        // Compile filter data for saving.
        for (const key in this.filters) {
            const filter = this.filters[key];
            if (filter.isApplied && filter.saveValue) {
                data[key] = filter.saveValue;
            }
        }
        let listing = null;

        if(recentVehicle){
            listing = recentVehicle['@LISTING_SEQ'];
        }
        let  returnDealers = [];
        if (typeof data['regions'] !== "undefined") {
            if(data['regions'] == north_island_string || data['regions'] == south_island_string){
                returnDealers = dealerships.filter(
                        (d) => d.island === data['regions']
                    )
            }else {
                returnDealers = dealerships.filter(
                    (d) => d.region_ID === data['regions']
                )
            }
            if(typeof data['dealerships'] === "undefined"){
                data['regionDealers'] = returnDealers.map(item => item?.data?.autoplay?.dealer);
            }
        }
        if(this.state.dealershipLabel !== null){
            data['dealershipLabel'] = this.state.dealershipLabel;
        }
        if(this.state.regionLabel !== null){
            data['regionLabel'] = this.state.regionLabel;
        }
        data['savedUrlString'] = this.state.savedUrlString;

        // Save the search filters.
        searchService.saveSearch(data, this.state.saveSearchEmail, listing)
            .then((data) => {
                // Inform the user the search has been saved.
                this.setState({
                    saveSearchEmail: '',
                    saveSearchSaved: true
                });
            })
            .catch((err) => {
                // TODO show a save failed status.
            });
    };


    /**
     * A method to determine if any filters, other than 'sort', have been applied.
     *
     * This function iterates through the `filters` object, checks if
     * each filter has the `isApplied` property set to true, and excludes
     * the 'sort' filter from the evaluation. If at least one qualifying
     * filter is applied, it returns true; otherwise, it returns false.
     *
     * @returns {boolean} Returns true if any filters except 'sort'
     * are applied, otherwise false.
     */
    isFilters = () => {
        for (const key in this.filters) {
            if (this.filters[key].isApplied && key !== 'sort') {
                return true;
            }
        }
        return false;
    };

    clearFilters = () => {
        for (const key in this.filters) {
            this.filters[key].clear();
        }
        this.setState(() => ({
            showingSaveSearch: false,
            saveSearchSaved: false,
        }))
    };

    handleResize = () => {
        this.setState({ wh: w.h });

        if (w.w > 768) {
            this.closeSidebar();
            this.resetStickyFiltersTop();
        } else {
            this.adjustStickyFiltersTop();
        }
    };

    adjustStickyFiltersTop = () => {
        const topBarHeight = document.querySelector(".vehicles-filters__topBar").offsetHeight;
        const navBarElHeight = document.querySelector(".nav__bar").offsetHeight + topBarHeight;
        this.filterHeadRef.current.style.top = `${navBarElHeight}px`;
    };

    resetStickyFiltersTop = () => {
        if (this.filterHeadRef.current) {
            this.filterHeadRef.current.style.top = `0px`;
        }
    };

    toggleSidebar = () => {
        this.setState({ showingSidebarDesktop: !this.state.showingSidebarDesktop });
    };

    checkFilters = (filters, state) => {
        let foundFilters = [];
        const urlFilters = filters.split(',')
        urlFilters.forEach(item => {
            // Convert the checkName to lowercase for case-insensitive comparison
            const lowerCheckName = item.toLowerCase();

            // Find the object whose 'name' matches the checkName (case insensitive)
            const match = custom_filter_fields.find(item => item.name.toLowerCase() === lowerCheckName);

            if (match) {
               state = (processFilterOn(match, state, makes, models, regions, dealerships, years));
               state.filters[match['name']] = true;
            }
        });
        return state;
    }
    changeFilter = (filter) => {
        const name = filter['name'];
        let previousState = this.state;
        let isOn = this.state.filters[name];

        Object.keys(this.state.filters).forEach(key => {
            if(this.state.filters[key]){
                const match = custom_filter_fields.find(item => item.name.toLowerCase() === key);
                previousState = processFilterOff(match, previousState, makes, models, regions, dealerships, years)
            }
            previousState.filters[key] = false;
        });


        let state = previousState;
        if(!isOn){
            state = processFilterOn(filter, previousState, makes, models, regions, dealerships, years)
        }
        this.setState(e => ({
            ...state,
            filters: {
                ...e.filters,
                [filter['name']]: !isOn
            }
        }), () => {
            this.updateDataLayer();
            this.setUrlFormating();
        });

    }

    findMakeLabelWithId = (makeId) => {
        const found = makes.find(item =>  {
            return item['MAKE_SEQ'] == makeId;
        })

        return found;
    }

    closeSidebar = () => {
        if (!this.state.showingSidebar) return;
        this.overlay.hide();
        this.setState({ showingSidebar: false });
    };

    showSidebar = () => {
        if (this.state.showingSidebar) return;
        this.overlay.show();
        this.setState({ showingSidebar: true });
    };

    render() {
        const {
            showing,
            wh,
            showingSaveSearch,
            showingSidebar,
            showingSidebarDesktop,
            make,
            showFilterLoading,
            saveSearchEmail,
            saveSearchSaved
        } = this.state;
        const vehicles = sortVehicles(this.state, this.props.vehicles, this.filters);
        const items = this.renderItems(vehicles);

        let maxHeightFloat = "90vh";
        if(items.length <= 3){
            maxHeightFloat = "880px";
        }
        const makeList = this.renderMakes();
        const validationSchema = Yup.object().shape({
            email: Yup.string().email('Invalid email').required('Required'),
        });
        const initialValues = {
            email: '',
        };

        return (
            <Fragment>
                {/*{this.renderHero()}*/}
                {/*{this.renderBrandBanner()}*/}
                {!hideUI && (
                    <Fragment>
                    <VehicleFiltersTopbar
                        toggle={this.toggleSidebar}
                        filters={this.filters}
                        stateFilters={this.state.filters}
                        changeFilter={this.changeFilter}
                        customFilters={custom_filter_fields}
                        ref={this.topBarRef}
                    />
                        <div
                            className={`vehicles-filters__sidebar ${showingSidebarDesktop ? "" : "hide-display"}`}
                            style={{height: wh + "px", maxHeight: maxHeightFloat}}
                        >
                            <div className={`vehicles-filters__sidebar-wrap`}>
                                <div
                                    className={
                                        `vehicles-filters__loading ` + "show"
                                    }
                                >
                                    <div
                                        className={`vehicles-filters__loading-stick`}
                                    ></div>
                                </div>
                                <div
                                    className={`vehicles-filters__sidebar-head`}
                                >
                                </div>
                                {this.renderFilters()}
                            </div>
                        </div>
                        <div className={`vehicles-filters__container-float ${showingSidebarDesktop ? "" : "hide-display"}`}>
                            <div
                                className={`vehicles-filters__container-float_button`}
                            >
                                <Button
                                    title={`Apply Filters`}
                                    modifiers={['solid', 'yellow', 'medium']}
                                    chevron={false}
                                    onClick={this.toggleSidebar}
                                />
                            </div>
                        </div>
                    </Fragment>)
                }

                <div
                    className={`vehicles-filters__container ${custom_filter_fields.length == 0 ? "no-mobile-padding" : ""} ${
                        showingSidebarDesktop ? "sidebar-showing" : ""
                    }`}>
                    <div
                        className={`vehicles-filters__sidebar hide-display-desktop ${
                            showingSidebar ? "is-showing" : ""
                        }`}
                        style={{height: wh + "px", zIndex: 0, maxHeight: maxHeightFloat}}
                    >

                        <div className={`vehicles-filters__sidebar-wrap`}>
                            <div
                                className={`vehicles-filters__sidebar-head`}
                            >
                                <div
                                    className={
                                        `vehicles-filters__sidebar-h ` +
                                        (this.renderCount() == 0
                                            ? "no-count"
                                            : undefined)
                                    }
                                    data-count={this.renderCount()}
                                >
                                    Filters and search
                                </div>
                                <div
                                    className={`vehicles-filters__sidebar-close`}
                                    onClick={this.closeSidebar}
                                ></div>
                            </div>

                            {this.renderFilters()}
                        </div>
                    </div>
                    <div className={`vehicles-filters__wrap`}>
                        <div className={`vehicles-filters__body`}>
                            {!hideUI && (<div
                                className={`vehicles-filters__head`}
                                ref={this.filterHeadRef}
                            >
                                <div
                                    className={`vehicles-filters__filters-trigger`}
                                    onClick={this.showSidebar}
                                >
                                    <span
                                        data-count={this.renderCount()}
                                        className={
                                            this.renderCount() == 0
                                                ? "no-count"
                                                : undefined
                                        }
                                    >
                                        Filters
                                    </span>
                                </div>

                                <div className={`vehicles-filters__head-left`}>
                                    <div className={`vehicles-filters__found`}>
                                        Results found: {items.length} vehicles
                                    </div>

                                    {this.isFilters() ? (
                                        <button
                                            onClick={this.clearFilters}
                                            className={`vehicles-filters__clear vehicles-filters__clear--head`}
                                        >
                                            Clear filters
                                        </button>
                                    ) : null}
                                </div>

                                <div className={`vehicles-filters__sort`}>
                                    <Select
                                        onChange={({value}) => {
                                            this.triggerFilterLoading();

                                            this.setState({sort: value}, () => {
                                                this.updateDataLayer();
                                            });


                                            this.state.urlArray[6] = value;
                                            this.setUrlFormating();
                                        }}
                                        id={`sortOptions`}
                                        options={sortOptions}
                                        defaultValue={sortOptions[0]}
                                        value={this.state.sort}
                                        pre={`Sort by:`}
                                        modifiers={["sort"]}
                                        searchable={false}
                                    />
                                </div>
                            </div>)}
                            {!hideUI && (
                                <div className={`vehicles-filters__crumbs`}>
                                    {this.renderCount() != 0 ? (
                                        <button
                                            onClick={this.toggleSaveSearch}
                                            className={"vehicles-filters__save"}
                                        >
                                            Save this search
                                        </button>) : (null)
                                    }
                                    {this.renderCrumbs()}
                                    {(showingSaveSearch) ? (

                                        <div className={`sign-up-modal`}>
                                            <Formik
                                                validateOnMount={isInitialValid}
                                                validationSchema={validationSchema}
                                                onSubmit={() => this.saveSearch(vehicles)}
                                                initialValues={initialValues}
                                            >
                                                {formikProps => {
                                                    this.formik = formikProps;
                                                    return (
                                                        <Form>
                                                            <div className={`popup__close`}
                                                                 onClick={this.toggleSaveSearch}></div>
                                                            <h3 className={``}>{!saveSearchSaved ? ('Save This Search') : ("Search Saved")}</h3>
                                                            {!saveSearchSaved ? (
                                                                <p>Receive a daily email update containing any new vehicles
                                                                    that match your search. Unsubscribe at any time.</p>
                                                            ) : null}
                                                            <h4>Your current filters</h4>
                                                            <div className={'current-filters'}>{this.renderCrumbs()}</div>
                                                            {!saveSearchSaved ? (
                                                                    <div className={`form-group`}>
                                                                        <Input
                                                                            name={`email`}
                                                                            type="email"
                                                                            modifiers={['form']}
                                                                            form={this.formik}
                                                                            placeholder="Enter your email"
                                                                            onChange={(e) => {
                                                                                this.setState({saveSearchEmail: e.target.value})
                                                                            }
                                                                            } // Update state
                                                                            className="input input--email"
                                                                        />
                                                                        <Button
                                                                            title={`Submit`}
                                                                            modifiers={['solid', 'yellow', 'medium']}
                                                                            chevron={true}
                                                                            type="submit"
                                                                            disabled={!this.formik.isValid}
                                                                        /></div>) :
                                                                null}
                                                        </Form>)
                                                }}
                                            </Formik>
                                        </div>
                                    ) : null}
                                </div>)
                            }


                            {items.length !== 0 ? (
                                <div className={`vehicles-filters__list`}>
                                    {items.slice(0, showing)}

                                    {items.length >= showing ? (
                                        <div
                                            className={`vehicles-filters__cta`}
                                            ref={this.loadMoreRef}
                                        >
                                            <Button
                                                title={`Show more vehicles`}
                                                modifiers={["outline", "grey"]}
                                                onClick={this.showMore}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            ) : (
                                <div className="notice">
                                    <div className="notice__wrap">
                                        <div className="notice__body">
                                            <h3 className="notice__title">
                                                No results found
                                            </h3>
                                            <div className="notice__text">
                                                <button
                                                    onClick={this.clearFilters}
                                                    className={`vehicles-filters__clear`}
                                                >
                                                    Clear filters
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            { !hideUI && (
                                <div className={`container pt-5`}>
                                <div className={`row pb-3`}>
                                    <h3>Explore our brands</h3>
                                    </div>
                                    {makeList.length !== 0 ? (
                                        <div className={`row`}>
                                            {makeList}
                                        </div>
                                    ) : ("")}
                                </div>
                            )}

                        </div>
                    </div>
                    <div className={`vehicles-filters__container-float hide-display-desktop`}>
                        <div
                            className={`vehicles-filters__container-float_button ${showingSidebar ? "is-showing" : ""}`}>
                            <Button
                                title={`Apply Filters`}
                                modifiers={['solid', 'black', 'large']}
                                chevron={true}
                                onClick={this.closeSidebar}
                            />
                            <div
                                className={`vehicles-filters__sidebar-close-parent`}
                                onClick={this.clearFilters}
                            >
                                <div
                                    className={`vehicles-filters__sidebar-close`}
                                />
                                <p>Clear all</p>
                            </div>

                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default function (el, props) {
    ReactDOM.render(<VehiclesFilters {...props} />, el);
}
